var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTranslation(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 101,
    viewBox: "0 0 140 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94.5202 71.0247L87.4148 66.9195C86.7615 66.5737 86.031 66.3998 85.2919 66.4144V66.3897H68.962V84.8082H85.2919V84.7912C86.0318 84.8035 86.7626 84.6263 87.4148 84.2766L94.5202 80.1752V71.0247Z",
    fill: "black",
    fillOpacity: 0.3
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5202 30.9837L87.4148 26.8785C86.7615 26.5326 86.031 26.3588 85.2919 26.3734V26.3487H68.962V44.7672H85.2919V44.7502C86.0318 44.7625 86.7626 44.5853 87.4148 44.2356L94.5202 40.1342V30.9837Z",
    fill: "black",
    fillOpacity: 0.3
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2661 24.9565C85.434 25.6325 85.434 26.7357 84.2661 27.4098L71.3542 34.8627C70.1864 35.5368 68.2743 35.5368 67.1065 34.8627L54.1945 27.4098C53.0268 26.7357 53.0268 25.6325 54.1945 24.9565L67.1065 17.5056C68.2743 16.8315 70.1864 16.8315 71.3542 17.5056L84.2661 24.9565Z",
    fill: "#E0E7FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2658 27.4103L71.3538 34.8633C70.186 35.5373 68.2739 35.5373 67.1061 34.8633L54.1942 27.4103C53.6112 27.0743 53.3187 26.6299 53.3187 26.1837V35.8069C53.3187 36.2512 53.6112 36.6956 54.1942 37.0336L67.1061 44.4846C68.2739 45.1606 70.186 45.1606 71.3538 44.4846L84.2658 37.0336C84.8354 36.6975 85.1373 36.2569 85.1411 35.8165V26.1932C85.1354 26.6356 84.8354 27.0762 84.2658 27.4103Z",
    fill: "url(#paint0_linear_722_15716)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4368 36.1809L56.8701 31.8137C56.4201 31.5535 56.0536 31.7643 56.0536 32.2845V38.1026L65.2552 43.4192V37.5955C65.2397 37.312 65.1575 37.0361 65.0153 36.7903C64.8731 36.5445 64.675 36.3357 64.4368 36.1809Z",
    fill: "url(#paint1_linear_722_15716)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0256 36.1809L81.5924 31.8137C82.0444 31.5535 82.4108 31.7643 82.4108 32.2845V38.1026L73.2091 43.4192V37.5955C73.2246 37.3122 73.3067 37.0365 73.4485 36.7908C73.5903 36.545 73.788 36.3361 74.0256 36.1809Z",
    fill: "url(#paint2_linear_722_15716)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2556 42.4706V43.4143L66.0721 43.8852L65.2556 42.4706Z",
    fill: "#F1F1F6"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M48.9153 53.7934L52.2743 51.8527L66.0712 43.8872L65.2547 43.4163L51.4559 51.3818L48.0969 53.3206L48.9153 53.7934Z",
    fill: "url(#paint3_linear_722_15716)"
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7401 52.5844L51.4561 50.4387L65.2548 42.4732V37.5989C65.2392 37.3154 65.157 37.0395 65.0149 36.7937C64.8726 36.5479 64.6745 36.3392 64.4364 36.1843L61.1116 34.2646L38.5593 47.2848L47.7401 52.5844Z",
    fill: "#F4F4F8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7407 52.5818V53.5255L65.2554 43.4143V42.4706L47.7407 52.5818Z",
    fill: "url(#paint4_linear_722_15716)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M90.7215 52.5844L87.0056 50.4387L73.2068 42.4732V37.5989C73.2224 37.3154 73.3047 37.0395 73.4468 36.7937C73.589 36.5479 73.7872 36.3392 74.0252 36.1843L77.35 34.2646L99.9023 47.2848L90.7215 52.5844Z",
    fill: "#F4F4F8"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M90.7238 52.5818V53.5255L73.2091 43.4143V42.4706L90.7238 52.5818Z",
    fill: "url(#paint5_linear_722_15716)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5029 52.9265C90.4998 52.8505 90.4786 52.7763 90.4409 52.7103C90.4032 52.6442 90.3503 52.5881 90.2863 52.5468C90.1668 52.4765 90.0699 52.5334 90.0699 52.6721C90.0732 52.7481 90.0946 52.822 90.1323 52.8881C90.1699 52.9542 90.2227 53.0102 90.2863 53.0518C90.406 53.1297 90.5029 53.0652 90.5029 52.9265ZM89.4225 52.3037C89.4191 52.2278 89.3978 52.1537 89.3601 52.0876C89.3225 52.0217 89.2696 51.9655 89.2059 51.9239C89.0863 51.8556 88.9895 51.9107 88.9895 52.0493C88.9929 52.1252 89.0144 52.1992 89.052 52.2652C89.0897 52.3312 89.1424 52.3874 89.2059 52.4291C89.3256 52.4974 89.4225 52.4404 89.4225 52.3037ZM88.342 51.679C88.339 51.603 88.3178 51.5288 88.2801 51.4628C88.2424 51.3966 88.1894 51.3405 88.1256 51.2993C88.0059 51.229 87.909 51.2859 87.909 51.4226C87.9126 51.4986 87.9339 51.5725 87.9716 51.6386C88.0092 51.7046 88.0619 51.7607 88.1256 51.8024C88.2546 51.8726 88.342 51.8176 88.342 51.679ZM87.2616 51.0542C87.2582 50.9784 87.2369 50.9043 87.1992 50.8382C87.1616 50.7722 87.1087 50.7161 87.0451 50.6745C86.9254 50.6062 86.8286 50.6613 86.8286 50.7999C86.8316 50.8758 86.8528 50.95 86.8905 51.0161C86.9282 51.0823 86.9812 51.1383 87.0451 51.1796C87.1647 51.2499 87.2616 51.1929 87.2616 51.0542ZM86.1811 50.4315C86.1777 50.3555 86.1562 50.2815 86.1186 50.2156C86.0809 50.1495 86.0282 50.0934 85.9647 50.0518C85.845 49.9834 85.7462 50.0384 85.7462 50.177C85.7501 50.2531 85.7719 50.3272 85.8099 50.3931C85.8478 50.4592 85.9008 50.5152 85.9647 50.5568C86.0843 50.6251 86.1811 50.5682 86.1811 50.4315ZM85.0988 49.8067C85.0958 49.7308 85.0746 49.6566 85.0368 49.5905C84.9991 49.5243 84.9462 49.4683 84.8824 49.427C84.7627 49.3567 84.6658 49.4137 84.6658 49.5524C84.6691 49.6282 84.6906 49.7023 84.7282 49.7684C84.7658 49.8344 84.8186 49.8905 84.8824 49.9321C85.0019 50.0005 85.0988 49.9453 85.0988 49.8067ZM84.0184 49.184C84.015 49.108 83.9937 49.0339 83.9561 48.9679C83.9184 48.9018 83.8655 48.8457 83.8019 48.8041C83.6822 48.7359 83.5855 48.7909 83.5855 48.9295C83.5885 49.0055 83.6097 49.0797 83.6473 49.1458C83.685 49.2119 83.7381 49.268 83.8019 49.3092C83.9215 49.3776 84.0184 49.3207 84.0184 49.184ZM82.9379 48.5592C82.9345 48.4834 82.913 48.4093 82.8754 48.3433C82.8378 48.2773 82.785 48.2211 82.7215 48.1795C82.6018 48.1111 82.505 48.1662 82.505 48.3047C82.5084 48.3807 82.5297 48.4548 82.5673 48.5209C82.605 48.5869 82.6579 48.643 82.7215 48.6846C82.841 48.7624 82.9379 48.6978 82.9379 48.5592ZM81.8575 47.9345C81.8541 47.8586 81.8328 47.7845 81.7952 47.7185C81.7575 47.6524 81.7047 47.5964 81.641 47.5548C81.5214 47.4864 81.4246 47.5414 81.4246 47.6801C81.4276 47.7561 81.4488 47.8303 81.4865 47.8963C81.5241 47.9624 81.5772 48.0186 81.641 48.0598C81.7607 48.1301 81.8575 48.0732 81.8575 47.9345ZM80.777 47.3117C80.7736 47.2358 80.7521 47.1618 80.7145 47.0957C80.6769 47.0298 80.6241 46.9736 80.5606 46.9319C80.441 46.8636 80.3442 46.9187 80.3442 47.0572C80.3476 47.1332 80.3691 47.2072 80.4067 47.2731C80.4443 47.3392 80.4971 47.3954 80.5606 47.437C80.6803 47.5054 80.777 47.4503 80.777 47.3117ZM79.6966 46.687C79.6937 46.6108 79.6724 46.5364 79.6343 46.4702C79.5963 46.404 79.5428 46.3481 79.4783 46.3073C79.3587 46.237 79.2618 46.292 79.2618 46.4326C79.2653 46.5085 79.2867 46.5824 79.3243 46.6485C79.362 46.7145 79.4148 46.7706 79.4783 46.8123C79.5998 46.8806 79.6966 46.8256 79.6966 46.687ZM78.6143 46.0642C78.611 45.9883 78.5896 45.9142 78.552 45.8481C78.5144 45.7821 78.4614 45.726 78.3978 45.6844C78.2783 45.6161 78.1814 45.6712 78.1814 45.8097C78.1847 45.8857 78.2061 45.9598 78.2437 46.0257C78.2814 46.0918 78.3342 46.148 78.3978 46.1895C78.5175 46.2579 78.6143 46.2009 78.6143 46.0642ZM77.5338 45.4395C77.5304 45.3635 77.509 45.2895 77.4713 45.2236C77.4337 45.1575 77.381 45.1014 77.3174 45.0598C77.1978 44.9914 77.1009 45.0464 77.1009 45.185C77.1044 45.261 77.1259 45.3349 77.1634 45.401C77.2012 45.467 77.2539 45.5231 77.3174 45.5648C77.4314 45.6331 77.5338 45.5781 77.5338 45.4395ZM76.4535 44.8147C76.4502 44.7388 76.4288 44.6648 76.3911 44.5987C76.3535 44.5327 76.3007 44.4765 76.2369 44.435C76.1174 44.3647 76.0205 44.4217 76.0205 44.5604C76.0235 44.6363 76.0447 44.7105 76.0825 44.7766C76.1202 44.8426 76.1731 44.8987 76.2369 44.9401C76.3566 45.0104 76.4535 44.9533 76.4535 44.8147ZM75.3731 44.192C75.3695 44.116 75.3481 44.042 75.3104 43.976C75.2728 43.91 75.2201 43.8539 75.1565 43.8121C75.0369 43.7439 74.9401 43.7989 74.9401 43.9375C74.9436 44.0134 74.965 44.0874 75.0027 44.1534C75.0403 44.2195 75.093 44.2756 75.1565 44.3172C75.2762 44.3951 75.3731 44.3306 75.3731 44.192ZM74.2926 43.5672C74.2892 43.4914 74.2677 43.4173 74.2301 43.3513C74.1924 43.2853 74.1397 43.2291 74.0762 43.1875C73.9565 43.1191 73.8596 43.1761 73.8596 43.3127C73.8632 43.3887 73.8845 43.4627 73.9222 43.5287C73.9598 43.5947 74.0126 43.6509 74.0762 43.6926C74.2033 43.7609 74.2926 43.7058 74.2926 43.5672Z",
    fill: "#DFE4F4"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2254 37.6546L74.0465 42.9543L74.2554 43.0757L83.4361 37.7762L83.2254 37.6546ZM96.1943 45.1436L87.0155 50.4431L87.2244 50.5628L96.4051 45.2632L96.1943 45.1436ZM91.8727 42.6466L82.6918 47.9463L82.9026 48.0677L92.0814 42.7682L91.8727 42.6466ZM89.7099 41.3991L80.5309 46.6988L80.7398 46.8202L89.9207 41.5207L89.7099 41.3991ZM81.0645 36.4071L73.2091 40.9415V41.1846L81.2734 36.5287L81.1177 36.4375L81.0645 36.4071ZM94.0334 43.8941L84.8546 49.1956L85.0635 49.3153L94.2423 44.0157L94.0334 43.8941ZM78.3796 45.4511L78.5885 45.5708L87.7674 40.2712L87.5585 40.1516L78.3796 45.4511ZM79.1125 35.2811L79.0955 35.2716L78.9056 35.1615L73.2091 38.4483V38.6894L79.1125 35.2811ZM85.3787 38.904L76.2074 44.2055L76.4182 44.3252L85.5951 39.0237L85.3787 38.904ZM98.3476 46.393L89.1668 51.6926L89.3776 51.8141L98.5565 46.5146L98.5243 46.4956L98.3476 46.393Z",
    fill: "#F6F6FB"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M47.962 52.9265C47.965 52.8505 47.9863 52.7763 48.024 52.7103C48.0616 52.6442 48.1146 52.5881 48.1785 52.5468C48.2982 52.4765 48.3949 52.5334 48.3949 52.6721C48.3916 52.7481 48.3702 52.822 48.3326 52.8881C48.2949 52.9542 48.2421 53.0102 48.1785 53.0518C48.0588 53.1297 47.962 53.0652 47.962 52.9265ZM49.0425 52.3037C49.0458 52.2278 49.0672 52.1537 49.1048 52.0876C49.1425 52.0217 49.1953 51.9655 49.2589 51.9239C49.3785 51.8556 49.4754 51.9107 49.4754 52.0493C49.4719 52.1252 49.4504 52.1992 49.4129 52.2652C49.3753 52.3312 49.3224 52.3874 49.2589 52.4291C49.1373 52.4974 49.0425 52.4404 49.0425 52.3037ZM50.1229 51.679C50.1259 51.603 50.1472 51.5288 50.1848 51.4628C50.2225 51.3966 50.2755 51.3405 50.3394 51.2993C50.4589 51.229 50.5558 51.2859 50.5558 51.4226C50.5524 51.4986 50.5309 51.5725 50.4933 51.6386C50.4556 51.7046 50.4029 51.7607 50.3394 51.8024C50.2197 51.8726 50.1229 51.8176 50.1229 51.679ZM51.2034 51.0542C51.2066 50.9784 51.228 50.9043 51.2656 50.8382C51.3032 50.7722 51.3561 50.7161 51.4198 50.6745C51.5394 50.6062 51.6362 50.6613 51.6362 50.7999C51.6332 50.8758 51.612 50.95 51.5743 51.0161C51.5366 51.0823 51.4836 51.1383 51.4198 51.1796C51.3001 51.2499 51.2034 51.1929 51.2034 51.0542ZM52.2837 50.4315C52.2872 50.3555 52.3086 50.2815 52.3463 50.2156C52.3839 50.1495 52.4366 50.0934 52.5002 50.0518C52.6198 49.9834 52.7186 50.0384 52.7186 50.177C52.7147 50.2531 52.693 50.3272 52.655 50.3931C52.617 50.4592 52.564 50.5152 52.5002 50.5568C52.3806 50.6251 52.2837 50.5682 52.2837 50.4315ZM53.3641 49.8067C53.3676 49.7307 53.3892 49.6564 53.4271 49.5903C53.4651 49.5242 53.5184 49.4683 53.5826 49.427C53.7021 49.3567 53.799 49.4137 53.799 49.5524C53.7957 49.6282 53.7743 49.7023 53.7366 49.7684C53.699 49.8344 53.6462 49.8905 53.5826 49.9321C53.4629 50.0005 53.366 49.9453 53.3641 49.8067ZM54.4541 49.184C54.4574 49.108 54.4788 49.0339 54.5164 48.9679C54.554 48.9018 54.607 48.8457 54.6706 48.8041C54.7901 48.7359 54.887 48.7909 54.887 48.9295C54.884 49.0055 54.8628 49.0797 54.8251 49.1458C54.7875 49.2119 54.7344 49.268 54.6706 49.3092C54.5433 49.3776 54.4541 49.3207 54.4541 49.184ZM55.5269 48.5592C55.5303 48.4834 55.5518 48.4093 55.5894 48.3433C55.6271 48.2773 55.6798 48.2211 55.7433 48.1795C55.863 48.1111 55.9599 48.1662 55.9599 48.3047C55.9566 48.3807 55.9352 48.4548 55.8975 48.5209C55.8599 48.5869 55.8071 48.643 55.7433 48.6846C55.6238 48.7624 55.5269 48.6978 55.5269 48.5592ZM56.6073 47.9345C56.6107 47.8586 56.632 47.7845 56.6697 47.7185C56.7073 47.6524 56.7602 47.5964 56.8238 47.5548C56.9435 47.4864 57.0403 47.5414 57.0403 47.6801C57.0372 47.7561 57.0161 47.8303 56.9784 47.8963C56.9407 47.9624 56.8877 48.0186 56.8238 48.0598C56.7042 48.1301 56.6073 48.0732 56.6073 47.9345ZM57.6821 47.3117C57.6856 47.2358 57.707 47.1618 57.7446 47.0957C57.7822 47.0298 57.835 46.9736 57.8985 46.9319C58.0182 46.8636 58.115 46.9187 58.115 47.0572C58.1115 47.1332 58.0901 47.2072 58.0525 47.2731C58.0149 47.3392 57.9621 47.3954 57.8985 47.437C57.7847 47.5054 57.6821 47.4503 57.6821 47.3117ZM58.7682 46.687C58.7712 46.611 58.7925 46.5368 58.8302 46.4708C58.8678 46.4046 58.9208 46.3485 58.9847 46.3073C59.1062 46.237 59.203 46.292 59.203 46.4326C59.1995 46.5087 59.1779 46.5829 59.1398 46.6489C59.1019 46.7149 59.0487 46.771 58.9847 46.8123C58.8651 46.8806 58.7682 46.8256 58.7682 46.687ZM59.8505 46.0642C59.8539 45.9883 59.8752 45.9142 59.9128 45.8481C59.9505 45.7821 60.0034 45.726 60.067 45.6844C60.1867 45.6161 60.2834 45.6712 60.2834 45.8097C60.2801 45.8857 60.2587 45.9598 60.2211 46.0257C60.1834 46.0918 60.1306 46.148 60.067 46.1895C59.9474 46.2579 59.8505 46.2009 59.8505 46.0642ZM60.931 45.4395C60.9344 45.3635 60.9559 45.2895 60.9935 45.2236C61.0311 45.1575 61.0839 45.1014 61.1474 45.0598C61.2671 44.9914 61.3639 45.0464 61.3639 45.185C61.3604 45.261 61.339 45.3349 61.3014 45.401C61.2638 45.467 61.2109 45.5231 61.1474 45.5648C61.0279 45.6331 60.931 45.5781 60.931 45.4395ZM62.0114 44.8147C62.0148 44.7388 62.0361 44.6648 62.0737 44.5987C62.1114 44.5327 62.1642 44.4765 62.2279 44.435C62.3474 44.3647 62.4443 44.4217 62.4443 44.5604C62.4413 44.6363 62.4201 44.7105 62.3824 44.7766C62.3448 44.8426 62.2917 44.8987 62.2279 44.9401C62.1082 45.0104 62.0114 44.9533 62.0114 44.8147ZM63.0919 44.192C63.0953 44.116 63.1168 44.042 63.1544 43.976C63.192 43.91 63.2448 43.8539 63.3083 43.8121C63.4279 43.7439 63.5248 43.7989 63.5248 43.9375C63.5213 44.0134 63.4998 44.0874 63.4622 44.1534C63.4245 44.2195 63.3718 44.2756 63.3083 44.3172C63.1886 44.3951 63.0919 44.3306 63.0919 44.192ZM64.1723 43.5672C64.1758 43.4914 64.1971 43.4173 64.2348 43.3513C64.2724 43.2853 64.3251 43.2291 64.3888 43.1875C64.5083 43.1191 64.6052 43.1761 64.6052 43.3127C64.6017 43.3887 64.5803 43.4627 64.5427 43.5287C64.505 43.5947 64.4523 43.6509 64.3888 43.6926C64.2691 43.7609 64.1723 43.7058 64.1723 43.5672Z",
    fill: "#DFE4F4"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0246 37.775L64.2055 43.0746L64.4143 42.953L55.2392 37.6535L55.0246 37.775ZM42.0557 45.2621L51.2365 50.5617L51.4454 50.442L42.2645 45.1424L42.0557 45.2621ZM46.3793 42.767L55.5582 48.0666L55.7689 47.945L46.5882 42.6455L46.3793 42.767ZM48.5402 41.5195L57.7209 46.8191L57.9298 46.6975L48.7585 41.398L48.5402 41.5195ZM57.3431 36.4364L57.1874 36.5275L65.2516 41.1833V40.9403L57.3963 36.406L57.3431 36.4364ZM44.2222 44.0146L53.4012 49.3141L53.61 49.1945L44.4311 43.893L44.2222 44.0146ZM50.9156 40.1504L50.7067 40.2701L59.8856 45.5697L60.0945 45.45L50.9156 40.1504ZM65.2555 38.6864V38.4453L59.559 35.1584L59.3692 35.2686L59.352 35.2781L65.2555 38.6864ZM52.8676 39.0226L62.0502 44.3221L62.261 44.2025L53.0803 38.901L52.8676 39.0226ZM39.9309 46.4924L39.8986 46.5115L49.0775 51.8111L49.2883 51.6895L40.1074 46.39L39.9309 46.4924Z",
    fill: "#F6F6FB"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M75.9776 44.9903L75.9795 44.0694L73.2091 42.4706V43.4143L75.9776 44.9903Z",
    fill: "url(#paint6_linear_722_15716)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M91.0219 42.131L77.3714 34.2509L74.0256 36.182C73.788 36.3372 73.5903 36.546 73.4485 36.7919C73.3067 37.0375 73.2246 37.3133 73.2091 37.5966V42.4709L75.9719 44.0659H89.6434L91.2858 43.1164C91.3376 43.0926 91.3802 43.0528 91.4075 43.0029C91.4349 42.9529 91.4455 42.8957 91.4378 42.8393C91.4293 42.6967 91.3873 42.5582 91.315 42.4352C91.2427 42.3121 91.1423 42.2078 91.0219 42.131Z",
    fill: "url(#paint7_linear_722_15716)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M59.6677 43.1331L58.0784 42.7419L57.7709 42.9204L52.8034 42.1305L51.7763 42.7249L53.2421 42.9565L51.4287 44.0046L49.1501 44.2363L49.3002 45.5085L54.1478 45.011L54.634 44.728L60.1292 44.2533L60.7596 43.8888L59.6677 43.1331Z",
    fill: "url(#paint8_linear_722_15716)"
  }), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6441 40.6459L50.4688 39.9661L51.7751 42.7213L52.9505 43.4011L51.6441 40.6459Z",
    fill: "#A3A9D0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1737 39.4311L49.9983 38.7513L50.9326 38.2121L52.1098 38.8899L51.1737 39.4311ZM51.0996 42.4123L49.9243 41.7325L51.0066 41.1077L52.1839 41.7856L51.0996 42.4123Z",
    fill: "#F6F6FB"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9508 43.4024L52.5558 42.5555L50.7424 43.6036L50.3399 44.9157L49.3126 45.5081L51.1811 39.4319L52.1173 38.8907L53.9875 42.8099L52.9508 43.4024ZM51.6445 40.6471L51.0995 42.413L52.1837 41.7864L51.6445 40.6471Z",
    fill: "#BBC0E6"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3046 45.5065L48.1274 44.8267L49.9978 38.7504L51.1731 39.4302L49.3046 45.5065Z",
    fill: "#CED3F8"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1453 38.2756L49.968 37.5959C49.9239 37.575 49.8751 37.5664 49.8266 37.5711C49.7782 37.5758 49.7318 37.5935 49.6927 37.6225C49.581 37.6972 49.4885 37.7972 49.4225 37.9142C49.3565 38.0313 49.319 38.1622 49.3128 38.2965C49.3073 38.3447 49.3146 38.3937 49.3344 38.4381C49.3541 38.4824 49.3854 38.5208 49.425 38.5491L50.6022 39.2269L51.1453 38.2756Z",
    fill: "url(#paint9_linear_722_15716)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2586 38.5284C51.2513 38.6634 51.2123 38.7948 51.1446 38.9119C51.077 39.029 50.9827 39.1286 50.8694 39.2024C50.8321 39.235 50.7856 39.2551 50.7363 39.26C50.6871 39.2648 50.6376 39.2541 50.5946 39.2296C50.5518 39.2049 50.5177 39.1674 50.4971 39.1223C50.4766 39.0773 50.4706 39.0269 50.4801 38.9784C50.4874 38.8433 50.5265 38.7119 50.5941 38.5948C50.6618 38.4777 50.756 38.3781 50.8694 38.3043C50.9066 38.2717 50.9531 38.2516 51.0024 38.2467C51.0517 38.2419 51.1012 38.2526 51.1441 38.2772C51.187 38.3019 51.2211 38.3394 51.2416 38.3844C51.2622 38.4294 51.2681 38.4798 51.2586 38.5284Z",
    fill: "#BBC0E6"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4265 37.5359L51.2493 36.8561C51.2051 36.8362 51.1563 36.8282 51.1081 36.8328C51.0598 36.8375 51.0136 36.8547 50.9739 36.8827C50.8626 36.9577 50.7704 37.0578 50.7044 37.1749C50.6385 37.2919 50.6008 37.4226 50.5942 37.5568C50.5884 37.6051 50.5957 37.654 50.6155 37.6985C50.6351 37.7429 50.6665 37.7813 50.7062 37.8093L51.8835 38.4891L52.4265 37.5359Z",
    fill: "url(#paint10_linear_722_15716)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5413 37.7871C52.534 37.9221 52.4949 38.0536 52.4273 38.1707C52.3597 38.2879 52.2654 38.3874 52.152 38.4613C52.1148 38.4938 52.0683 38.514 52.019 38.5188C51.9698 38.5236 51.9202 38.513 51.8774 38.4883C51.8345 38.4636 51.8003 38.4261 51.7799 38.3811C51.7593 38.336 51.7533 38.2857 51.7629 38.2371C51.7703 38.1021 51.8094 37.9707 51.877 37.8536C51.9446 37.7366 52.0388 37.6371 52.152 37.5631C52.1893 37.5305 52.2358 37.5104 52.2851 37.5055C52.3343 37.5006 52.3838 37.5113 52.4268 37.536C52.4697 37.5607 52.5037 37.5981 52.5243 37.6432C52.5449 37.6882 52.5508 37.7385 52.5413 37.7871Z",
    fill: "#BBC0E6"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M64.4349 42.3341L62.8266 41.4055L61.7708 39.1668H60.5233L61.4215 41.1188L60.2366 41.9315L61.8468 42.86H63.5253L64.4349 42.3341Z",
    fill: "url(#paint11_linear_722_15716)"
  }), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7418 41.119V39.8678L59.1057 38.4835V39.7367L59.7418 41.119ZM60.2374 41.9318V40.6785L61.8476 41.6071V42.8603L60.2374 41.9318Z",
    fill: "#5652CC"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3594 41.323V40.0698L60.2368 40.6793V41.9326L56.3594 41.323ZM61.847 42.8611V41.6079L62.7565 41.0838V42.3351L61.847 42.8611Z",
    fill: "#423EAF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M62.757 41.0838L61.8474 41.6078L60.2372 40.6793L56.3541 40.0698L57.3397 39.5002L59.7359 39.8686L59.0998 38.4843L60.0854 37.9147L61.1411 40.1533L62.757 41.0838Z",
    fill: "#807DFB"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M90.36 43.1454L86.5263 40.9428C86.1466 40.7225 84.4167 40.7225 84.0351 40.9428L80.2014 43.1454C79.8215 43.3657 79.8215 43.7265 80.2014 43.9486L83.7902 46.0107V46.3165H85.8314C86.0733 46.3213 86.3124 46.2645 86.5263 46.1513L90.36 43.9486C90.7417 43.7284 90.7417 43.3657 90.36 43.1454Z",
    fill: "url(#paint12_linear_722_15716)"
  }), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4851 44.9631C84.2699 45.0718 84.0321 45.1284 83.7911 45.1284C83.5499 45.1284 83.3122 45.0718 83.097 44.9631L79.2633 42.7606C78.8836 42.5383 78.8836 42.1776 79.2633 41.9573L83.097 39.7547C83.3122 39.646 83.5499 39.5894 83.7911 39.5894C84.0321 39.5894 84.2699 39.646 84.4851 39.7547L88.3188 41.9573C88.6985 42.1776 88.6985 42.5402 88.3188 42.7606L84.4851 44.9631Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2637 42.7531L83.0975 44.9653C83.3127 45.0739 83.5504 45.1305 83.7914 45.1305C84.0326 45.1305 84.2702 45.0739 84.4855 44.9653L88.3192 42.7626C88.392 42.7285 88.4558 42.6778 88.5053 42.6144C88.5547 42.5511 88.5886 42.4769 88.604 42.3981V43.5221C88.6059 43.5455 88.6059 43.5691 88.604 43.5924C88.5882 43.6709 88.5542 43.7446 88.5047 43.8075C88.4552 43.8706 88.3917 43.9211 88.3192 43.9551L84.4855 46.1577C84.2702 46.2664 84.0326 46.323 83.7914 46.323C83.5504 46.323 83.3127 46.2664 83.0975 46.1577L79.2637 43.9551C79.1833 43.9196 79.1141 43.8628 79.0635 43.791C79.013 43.719 78.9831 43.6346 78.9771 43.5468V42.3563C78.9854 42.4419 79.0164 42.5237 79.0668 42.5934C79.1171 42.6631 79.1852 42.7183 79.2637 42.7531Z",
    fill: "url(#paint13_linear_722_15716)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3677 41.9061L82.5576 41.8415L82.59 41.889C83.245 42.3315 83.6874 42.734 83.9323 43.108C84.2354 43.0822 84.5399 43.0752 84.8438 43.0871L84.8989 43.3094C84.6168 43.2926 84.3341 43.2926 84.052 43.3094C84.1328 43.4533 84.1787 43.614 84.1863 43.7788C84.1938 43.9437 84.1628 44.1081 84.0957 44.2588C83.9669 44.2389 83.8368 44.2287 83.7064 44.2284C83.7761 44.0896 83.8099 43.9357 83.805 43.7804C83.8 43.6252 83.7563 43.4737 83.678 43.3397C83.4178 43.3606 83.1558 43.391 82.9184 43.427L83.0475 43.5562L82.6982 43.6189C82.4456 43.3569 82.0602 42.9904 81.6576 42.6239L81.2569 42.8556L81.0025 42.7093L81.4601 42.4454C81.2247 42.2346 80.9911 42.0353 80.7822 41.8586L81.1525 41.6916C81.1753 41.7105 81.1677 41.7333 81.1202 41.7656C81.3101 41.9232 81.5095 42.1073 81.7184 42.2973L82.3374 41.9403L82.3677 41.9061ZM81.9083 42.4757C82.1988 42.7397 82.4779 43.0113 82.7286 43.2505C82.9887 43.2068 83.2754 43.1708 83.5564 43.1384C83.261 42.7471 82.9006 42.4093 82.4912 42.1397L81.9083 42.4757ZM85.6641 41.1048L85.9262 41.2548L84.9577 41.8149L86.287 42.5745C86.5964 42.753 86.5243 42.8498 85.8046 43.2562C85.6842 43.2155 85.5611 43.1831 85.4362 43.1593L85.9262 42.8859C86.0629 42.8062 86.1028 42.7834 86.0173 42.734L84.6881 41.965L83.7046 42.5347L83.4425 42.3846L84.428 41.8149L83.7444 41.4219L83.885 41.3498C83.9109 41.1075 83.8903 40.8626 83.8241 40.6282L82.2785 41.5206L82.0259 41.3745L83.7767 40.3642L83.8128 40.3244L84.1584 40.2788C84.1584 40.2978 84.1584 40.3206 84.1337 40.3395C84.23 40.6744 84.2533 41.026 84.2021 41.3706L84.6996 41.6573L85.6641 41.1048Z",
    fill: "#807DFB"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M129 51.0042L121.895 46.899C121.241 46.5532 120.511 46.3793 119.772 46.3939V46.3692H103.442V64.7877H119.772V64.7707C120.512 64.783 121.242 64.6058 121.895 64.2561L129 60.1547V51.0042Z",
    fill: "black",
    fillOpacity: 0.3
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M118.578 44.7749C119.746 45.4489 119.746 46.5521 118.578 47.2263L105.666 54.6791C104.498 55.3531 102.586 55.3531 101.418 54.6791L88.5064 47.2263C87.3387 46.5521 87.3387 45.4489 88.5064 44.7749L101.418 37.322C102.588 36.6479 104.5 36.6479 105.668 37.322L118.578 44.7749Z",
    fill: "#E0E7FF"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M118.579 47.2176L105.667 54.6705C104.499 55.3445 102.587 55.3445 101.419 54.6705L88.5072 47.2176C87.9223 46.8815 87.6299 46.4372 87.6299 45.991V55.6142C87.6299 56.0585 87.9223 56.5028 88.5072 56.8409L101.419 64.2937C102.587 64.9677 104.499 64.9677 105.667 64.2937L118.579 56.8409C119.149 56.5066 119.45 56.0661 119.454 55.6237V46.0023C119.45 46.4429 119.158 46.8834 118.579 47.2176Z",
    fill: "url(#paint14_linear_722_15716)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7496 55.9926L91.1827 51.6254C90.7308 51.3652 90.3662 51.576 90.3662 52.0982V57.9162L99.5661 63.2328V57.4073C99.5508 57.1239 99.469 56.8481 99.3271 56.6023C99.1852 56.3565 98.9874 56.1476 98.7496 55.9926Z",
    fill: "url(#paint15_linear_722_15716)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5675 62.2794V63.2232L100.386 63.6959L99.5675 62.2794Z",
    fill: "#F1F1F6"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M83.2276 73.6006L86.5885 71.6619L100.385 63.6963L99.567 63.2236L85.7701 71.1891L82.4111 73.1298L83.2276 73.6006Z",
    fill: "url(#paint16_linear_722_15716)"
  }), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2938 72.2682L86.0098 70.1226L99.8066 62.1569V57.2827C99.7915 56.9993 99.7096 56.7235 99.5677 56.4777C99.4258 56.2319 99.2279 56.023 98.9902 55.8681L95.6654 53.956L73.113 66.9687L82.2938 72.2682Z",
    fill: "#F4F4F8"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2938 72.2671V73.2109L99.8066 63.0996V62.1559L82.2938 72.2671Z",
    fill: "url(#paint17_linear_722_15716)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2745 72.735C82.2782 72.6589 82.3 72.5849 82.3379 72.5188C82.3759 72.4527 82.429 72.3967 82.4929 72.3552C82.6125 72.2869 82.7094 72.3419 82.7094 72.4805C82.7063 72.5566 82.6852 72.6308 82.6475 72.6969C82.6098 72.7629 82.5568 72.819 82.4929 72.8604C82.3676 72.9305 82.2745 72.8774 82.2745 72.735ZM83.355 72.1179C83.3589 72.0419 83.3806 71.9678 83.4186 71.9018C83.4565 71.8358 83.5096 71.7797 83.5733 71.7381C83.693 71.6698 83.7898 71.7249 83.7898 71.8634C83.7863 71.9393 83.765 72.0134 83.7272 72.0793C83.6897 72.1454 83.6369 72.2016 83.5733 72.2432C83.4537 72.3078 83.355 72.2508 83.355 72.1179ZM84.4373 71.4875C84.4406 71.4115 84.462 71.3375 84.4996 71.2714C84.5373 71.2053 84.5901 71.1493 84.6537 71.1077C84.7734 71.0375 84.8702 71.0944 84.8702 71.233C84.8669 71.309 84.8455 71.3831 84.8079 71.449C84.7703 71.5151 84.7174 71.5713 84.6537 71.6127C84.5342 71.683 84.4373 71.6261 84.4373 71.4875ZM85.5177 70.8646C85.5212 70.7888 85.5427 70.7147 85.5803 70.6488C85.618 70.5827 85.6707 70.5265 85.7342 70.4849C85.8539 70.4165 85.9506 70.4716 85.9506 70.6102C85.9472 70.6861 85.9257 70.7601 85.8881 70.8262C85.8505 70.8921 85.7977 70.9483 85.7342 70.99C85.6146 71.0583 85.5177 71.0032 85.5177 70.8646ZM86.5982 70.2399C86.6012 70.1639 86.6224 70.0897 86.66 70.0237C86.6977 69.9576 86.7508 69.9015 86.8146 69.8602C86.9342 69.7899 87.0311 69.8469 87.0311 69.9836C87.0277 70.0596 87.0064 70.1336 86.9688 70.1996C86.9311 70.2657 86.8783 70.3218 86.8146 70.3634C86.695 70.4336 86.5982 70.3786 86.5982 70.2399ZM87.6843 69.6171C87.6881 69.5413 87.7097 69.4674 87.7473 69.4015C87.7848 69.3354 87.8375 69.2792 87.9007 69.2373C88.0204 69.169 88.1191 69.2241 88.1191 69.3627C88.1157 69.4389 88.0942 69.513 88.0561 69.5791C88.0182 69.6452 87.9649 69.7012 87.9007 69.7425C87.7773 69.8108 87.6843 69.7538 87.6843 69.6171ZM88.7591 68.9924C88.7628 68.9163 88.7846 68.8424 88.8226 68.7763C88.8605 68.7103 88.9136 68.6543 88.9774 68.6127C89.097 68.5443 89.1938 68.5993 89.1938 68.738C89.1904 68.8139 89.1689 68.8878 89.1313 68.9539C89.0937 69.0199 89.0409 69.076 88.9774 69.1177C88.8577 69.1861 88.7591 69.131 88.7591 68.9924ZM89.8414 68.3678C89.8444 68.2917 89.8656 68.2175 89.9032 68.1514C89.9409 68.0854 89.994 68.0293 90.0578 67.9879C90.1774 67.9176 90.2743 67.9747 90.2743 68.1133C90.271 68.1892 90.2496 68.2633 90.212 68.3293C90.1743 68.3953 90.1215 68.4515 90.0578 68.493C89.9382 68.5633 89.8414 68.5101 89.8414 68.3678ZM90.9217 67.7506C90.9253 67.6747 90.9466 67.6006 90.9843 67.5347C91.0219 67.4686 91.0747 67.4124 91.1383 67.3708C91.2579 67.3024 91.3547 67.3575 91.3547 67.4962C91.3517 67.5722 91.3305 67.6463 91.2928 67.7124C91.2551 67.7785 91.2021 67.8345 91.1383 67.8759C91.0186 67.9404 90.9217 67.8816 90.9217 67.7506ZM92.0022 67.1201C92.0052 67.0442 92.0264 66.97 92.0641 66.9039C92.1018 66.8379 92.1548 66.7817 92.2187 66.7404C92.3383 66.6701 92.4352 66.7252 92.4352 66.8639C92.4318 66.9397 92.4105 67.0138 92.3728 67.0799C92.3352 67.1459 92.2823 67.202 92.2187 67.2436C92.099 67.3139 92.0022 67.2588 92.0022 67.1201ZM93.0826 66.4955C93.0859 66.4195 93.1073 66.3455 93.145 66.2794C93.1826 66.2133 93.2354 66.1573 93.2992 66.1157C93.4187 66.0474 93.5156 66.1024 93.5156 66.241C93.5126 66.317 93.4914 66.3912 93.4537 66.4574C93.4159 66.5234 93.363 66.5795 93.2992 66.6207C93.1795 66.691 93.0826 66.6341 93.0826 66.4955ZM94.163 65.8726C94.1671 65.7968 94.1886 65.723 94.2262 65.6571C94.2638 65.5911 94.3163 65.5349 94.3795 65.4929C94.4992 65.4245 94.5979 65.4796 94.5979 65.6182C94.594 65.6942 94.5722 65.7683 94.5343 65.8343C94.4964 65.9003 94.4433 65.9564 94.3795 65.998C94.2618 66.0663 94.163 66.0112 94.163 65.8726ZM95.2435 65.2479C95.2468 65.1718 95.2685 65.0975 95.3064 65.0314C95.3445 64.9654 95.3978 64.9094 95.4618 64.8682C95.5815 64.7979 95.6784 64.8549 95.6784 64.9916C95.675 65.0675 95.6537 65.1416 95.616 65.2076C95.5784 65.2737 95.5256 65.3298 95.4618 65.3714C95.3423 65.4416 95.2435 65.3866 95.2435 65.2479ZM96.3239 64.6251C96.3276 64.5491 96.3493 64.4749 96.3873 64.4089C96.4253 64.3429 96.4784 64.2868 96.5423 64.2453C96.6619 64.177 96.7587 64.2321 96.7587 64.3707C96.7557 64.4467 96.7346 64.5208 96.6969 64.587C96.6592 64.6531 96.6062 64.7091 96.5423 64.7505C96.4189 64.8188 96.3239 64.7618 96.3239 64.6251ZM97.4063 64.0004C97.4093 63.9244 97.4305 63.8502 97.4682 63.7842C97.5058 63.718 97.5589 63.6619 97.6227 63.6207C97.7424 63.5504 97.8391 63.6054 97.8391 63.744C97.8357 63.82 97.8142 63.894 97.7766 63.96C97.739 64.026 97.6863 64.0821 97.6227 64.1239C97.5031 64.194 97.4063 64.1429 97.4063 64.0004ZM98.4867 63.3833C98.49 63.3073 98.5114 63.2333 98.549 63.1672C98.5867 63.1013 98.6395 63.0451 98.7031 63.0035C98.8228 62.9333 98.9196 62.9902 98.9196 63.1288C98.9162 63.2048 98.8949 63.2789 98.8573 63.3449C98.8196 63.4109 98.7668 63.4671 98.7031 63.5087C98.5836 63.5732 98.4867 63.5143 98.4867 63.3833Z",
    fill: "#DFE4F4"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M89.341 57.585L98.5199 62.8846L98.7306 62.7649L89.5499 57.4635L89.341 57.585ZM76.3721 65.074L85.5509 70.3735L85.7617 70.252L76.5809 64.9524L76.3721 65.074ZM80.6956 62.577L89.8746 67.8766L90.0834 67.7569L80.9045 62.4554L80.6956 62.577ZM82.8565 61.3295L92.0373 66.6291L92.2462 66.5075L83.0654 61.2079L82.8565 61.3295ZM91.6594 56.2463L91.5038 56.3375L99.568 60.9933V60.7522L91.7126 56.2159L91.6594 56.2463ZM78.5328 63.8245L87.7137 69.126L87.9226 69.0044L78.7436 63.7049L78.5328 63.8245ZM85.2281 59.9661L85.0174 60.0876L94.1982 65.3872L94.407 65.2657L85.2281 59.9661ZM99.568 58.504V58.2572L93.8715 54.9703L93.6817 55.0823L93.6664 55.0918L99.568 58.504ZM87.1801 58.8268L96.359 64.1264L96.5679 64.0068L87.389 58.7129L87.1801 58.8268ZM74.2434 66.2968L74.2112 66.3158L83.39 71.6153L83.5989 71.4939L74.4201 66.1942L74.2434 66.2968Z",
    fill: "#F6F6FB"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M96.9071 61.135L94.7101 61.1293L95.6899 61.6629L91.7726 63.9225H93.8252L97.7805 61.6382L96.9071 61.135Z",
    fill: "url(#paint18_linear_722_15716)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M86.5243 64.1936V64.224H86.7255C86.7408 64.6987 86.5142 65.0708 86.0458 65.3404C85.744 65.5137 85.4154 65.6356 85.0736 65.7013C85.3364 65.756 85.6047 65.7796 85.873 65.7716C86.4457 65.7689 87.0084 65.6206 87.5079 65.3404C87.9763 65.0708 88.2028 64.6987 88.1877 64.224L86.5243 64.1936Z",
    fill: "url(#paint19_linear_722_15716)"
  }), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2825 63.7123C85.4127 63.652 85.5182 63.5491 85.5817 63.4206C85.6453 63.2922 85.663 63.1458 85.632 63.0059L86.7295 63.0439C86.7447 63.5186 86.5181 63.8908 86.0498 64.1604C85.5508 64.4402 84.9888 64.5886 84.4168 64.5914C83.8416 64.6172 83.2707 64.4817 82.7685 64.2002C82.29 63.9231 82.0641 63.6034 82.0907 63.2414C82.1173 62.8793 82.3559 62.5686 82.8066 62.3091C83.0641 62.1651 83.341 62.059 83.6287 61.9939C83.9626 61.9144 84.3052 61.8768 84.6483 61.8818L84.7889 62.4857C84.571 62.4755 84.3528 62.4934 84.1395 62.5389C83.9537 62.5751 83.7746 62.6391 83.6078 62.7287C83.5125 62.7706 83.4291 62.8357 83.3651 62.9179C83.3012 63.0001 83.2587 63.0969 83.2413 63.1996C83.2262 63.3806 83.3528 63.5477 83.6212 63.7009C83.8831 63.8543 84.1838 63.9288 84.487 63.9155C84.7649 63.9143 85.0382 63.8444 85.2825 63.7123Z",
    fill: "#807DFB"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M84.1392 62.5399C83.9536 62.5762 83.7743 62.6402 83.6076 62.7297C83.5123 62.7717 83.429 62.8367 83.3649 62.9189C83.3009 63.0011 83.2585 63.0979 83.2412 63.2007C83.226 63.3816 83.3526 63.5488 83.6209 63.702C83.6933 63.7438 83.7689 63.7799 83.8468 63.8102C83.9437 63.7759 84.0427 63.748 84.1431 63.7267C84.3564 63.6812 84.5747 63.6633 84.7925 63.6735V62.4848C84.5734 62.4749 84.3538 62.4934 84.1392 62.5399Z",
    fill: "url(#paint20_linear_722_15716)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0486 64.1605C85.5497 64.4403 84.9877 64.5887 84.4157 64.5915C83.8406 64.6173 83.2696 64.4818 82.7675 64.2003C82.3365 63.9516 82.1124 63.6686 82.0916 63.3515V64.5649C82.1238 64.8707 82.3478 65.1459 82.7675 65.3871C83.2696 65.6686 83.8406 65.8041 84.4157 65.7782C84.9877 65.7755 85.5497 65.6271 86.0486 65.3473C86.5183 65.0776 86.7449 64.7055 86.7284 64.2308V63.0421C86.7437 63.5218 86.5171 63.8947 86.0486 64.1605Z",
    fill: "url(#paint21_linear_722_15716)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8926 60.0486V58.4555L92.2946 61.0208V62.612L92.8926 60.0486ZM89.0323 62.3405V60.7493L91.4875 59.3327V60.9239L89.0323 62.3405Z",
    fill: "#404882"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8172 59.5644L95.6906 60.0695L91.7734 62.3309L90.8999 61.8258L91.4885 59.3327L89.0334 60.7493L88.1599 60.2441L92.0771 57.9827L92.8955 58.4555L92.2956 61.0208L94.8172 59.5644Z",
    fill: "#212B75"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7726 63.9239V62.3308L95.6899 60.0693V61.6625L91.7726 63.9239Z",
    fill: "#404882"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8999 63.4194V61.8264L91.7734 62.3314V63.9226L90.8999 63.4194ZM88.1599 61.8377V60.2446L89.0334 60.7497V62.3409L88.1599 61.8377Z",
    fill: "#4D569E"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0405 51.0042L52.9351 46.899C52.2818 46.5532 51.5512 46.3793 50.8121 46.3939V46.3692H34.4823V64.7877H50.8121V64.7707C51.5521 64.783 52.2829 64.6058 52.9351 64.2561L60.0405 60.1547V51.0042Z",
    fill: "black",
    fillOpacity: 0.3
  }))), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9508 44.773C51.1204 45.4489 51.1204 46.5521 49.9508 47.2263L37.0388 54.6791C35.871 55.3531 33.959 55.3531 32.7892 54.6791L19.8773 47.2263C18.7076 46.5521 18.7076 45.4489 19.8773 44.773L32.7892 37.322C33.959 36.6479 35.8691 36.6479 37.0388 37.322L49.9508 44.773Z",
    fill: "#E0E7FF"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9508 47.2206L37.0388 54.6735C35.871 55.3476 33.959 55.3476 32.7892 54.6735L19.8773 47.2206C19.2924 46.8845 19 46.4401 19 45.9939V55.6172C19 56.0615 19.2924 56.5058 19.8773 56.8438L32.7892 64.2948C33.959 64.9708 35.871 64.9708 37.0388 64.2948L49.9508 56.8438C50.5318 56.5077 50.8242 56.0672 50.828 55.6266V46.0035C50.8242 46.4458 50.5318 46.8864 49.9508 47.2206Z",
    fill: "url(#paint22_linear_722_15716)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7137 55.9927L47.2805 51.6254C47.7324 51.3652 48.097 51.576 48.097 52.0963V57.9143L38.8972 63.231V57.4073C38.9127 57.124 38.9948 56.8483 39.1366 56.6026C39.2784 56.3568 39.4761 56.1479 39.7137 55.9927Z",
    fill: "url(#paint23_linear_722_15716)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4119 72.3937L52.694 70.2479L38.8972 62.2824V57.4081C38.9127 57.1248 38.9948 56.8491 39.1366 56.6033C39.2784 56.3576 39.4761 56.1487 39.7137 55.9935L43.0386 54.0795L65.5908 67.0997L56.4119 72.3937Z",
    fill: "#F4F4F8"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4119 72.3921V73.3359L38.8972 63.2246V62.2809L56.4119 72.3921Z",
    fill: "url(#paint24_linear_722_15716)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1906 72.7372C56.1876 72.6611 56.1663 72.5869 56.1286 72.5209C56.0909 72.4548 56.038 72.3987 55.9741 72.3574C55.8545 72.2872 55.7576 72.3441 55.7576 72.4827C55.7609 72.5587 55.7823 72.6328 55.82 72.6988C55.8576 72.7648 55.9104 72.8209 55.9741 72.8625C56.0937 72.9327 56.1906 72.8777 56.1906 72.7372ZM55.1101 72.1181C55.1068 72.0423 55.0854 71.9682 55.0479 71.9021C55.0101 71.836 54.9573 71.78 54.8937 71.7384C54.774 71.67 54.6773 71.7252 54.6773 71.8637C54.6807 71.9396 54.7021 72.0137 54.7398 72.0796C54.7774 72.1457 54.8301 72.2019 54.8937 72.2435C55.0133 72.3081 55.1101 72.251 55.1101 72.1181ZM54.0297 71.4897C54.0267 71.4136 54.0055 71.3394 53.9677 71.2734C53.9302 71.2073 53.8771 71.1512 53.8133 71.1099C53.6936 71.0397 53.5949 71.0966 53.5949 71.2333C53.5987 71.3094 53.6205 71.3834 53.6584 71.4494C53.6964 71.5154 53.7494 71.5716 53.8133 71.613C53.9328 71.6833 54.0297 71.6283 54.0297 71.4897ZM52.9493 70.8649C52.9456 70.7889 52.9239 70.7148 52.8859 70.6487C52.8479 70.5827 52.7948 70.5266 52.7309 70.4852C52.6112 70.4168 52.5145 70.4719 52.5145 70.6105C52.5175 70.6865 52.5387 70.7607 52.5763 70.8268C52.614 70.8929 52.6671 70.9489 52.7309 70.9903C52.8505 71.0605 52.9493 71.0035 52.9493 70.8649ZM51.8669 70.2421C51.8635 70.1662 51.842 70.0923 51.8044 70.0262C51.7668 69.9601 51.714 69.9041 51.6505 69.8624C51.5308 69.794 51.434 69.849 51.434 69.9877C51.4375 70.0636 51.459 70.1376 51.4965 70.2036C51.5341 70.2697 51.587 70.3257 51.6505 70.3674C51.7701 70.4358 51.8669 70.3789 51.8669 70.2421ZM50.7865 69.6174C50.7835 69.5414 50.7622 69.4672 50.7246 69.4011C50.6869 69.335 50.6339 69.279 50.57 69.2376C50.4505 69.1674 50.3536 69.2244 50.3536 69.363C50.3569 69.4389 50.3783 69.513 50.4159 69.579C50.4536 69.645 50.5064 69.7012 50.57 69.7427C50.6897 69.8111 50.7865 69.756 50.7865 69.6174ZM49.7079 68.9946C49.7047 68.9186 49.6832 68.8445 49.6457 68.7786C49.6081 68.7125 49.5551 68.6563 49.4915 68.6149C49.3719 68.5465 49.2751 68.6015 49.2751 68.7401C49.2781 68.8162 49.2993 68.8904 49.337 68.9564C49.3746 69.0225 49.4277 69.0786 49.4915 69.1199C49.6093 69.1882 49.7079 69.1313 49.7079 68.9946ZM48.6256 68.3698C48.6222 68.294 48.6007 68.22 48.5631 68.1539C48.5255 68.088 48.4728 68.0318 48.4092 67.9901C48.2896 67.9218 48.1927 67.9769 48.1927 68.1155C48.1961 68.1914 48.2174 68.2654 48.255 68.3315C48.2927 68.3975 48.3455 68.4537 48.4092 68.4952C48.5288 68.5636 48.6256 68.5104 48.6256 68.3698ZM47.5452 67.7509C47.5421 67.6747 47.5205 67.6004 47.4824 67.5343C47.4445 67.4682 47.3911 67.4122 47.3268 67.3711C47.2073 67.3027 47.1104 67.3578 47.1104 67.4964C47.1134 67.5725 47.1346 67.6466 47.1723 67.7127C47.2099 67.7788 47.263 67.8348 47.3268 67.8762C47.4465 67.9407 47.5452 67.8838 47.5452 67.7509ZM46.463 67.1223C46.4594 67.0465 46.438 66.9724 46.4003 66.9064C46.3627 66.8404 46.31 66.7843 46.2464 66.7426C46.1268 66.6742 46.03 66.7293 46.03 66.868C46.0334 66.9438 46.0549 67.0178 46.0925 67.0839C46.1302 67.1499 46.1829 67.206 46.2464 67.2477C46.3661 67.3161 46.463 67.2609 46.463 67.1223ZM45.3825 66.4977C45.3795 66.4216 45.3583 66.3474 45.3206 66.2814C45.2829 66.2153 45.2299 66.1592 45.166 66.1179C45.0464 66.0477 44.9495 66.1027 44.9495 66.2432C44.953 66.3191 44.9744 66.3931 45.012 66.4591C45.0497 66.5252 45.1024 66.5813 45.166 66.6229C45.2856 66.6913 45.3825 66.6363 45.3825 66.4977ZM44.3021 65.8748C44.2987 65.7989 44.2774 65.7248 44.2397 65.6588C44.2021 65.5928 44.1492 65.5366 44.0856 65.4951C43.966 65.4267 43.8691 65.4818 43.8691 65.6204C43.8724 65.6963 43.8938 65.7704 43.9315 65.8365C43.9691 65.9025 44.0219 65.9586 44.0856 66.0002C44.2014 66.0685 44.3021 66.0115 44.3021 65.8748ZM43.2216 65.2501C43.2182 65.1742 43.1967 65.1003 43.1591 65.0342C43.1214 64.9681 43.0687 64.9121 43.0052 64.8704C42.8855 64.802 42.7886 64.857 42.7886 64.9957C42.7922 65.0716 42.8135 65.1456 42.8513 65.2116C42.8888 65.2777 42.9416 65.3337 43.0052 65.3754C43.1248 65.4438 43.2216 65.3888 43.2216 65.2501ZM42.1412 64.6254C42.1379 64.5495 42.1165 64.4754 42.0788 64.4093C42.0412 64.3434 41.9884 64.2872 41.9247 64.2456C41.8051 64.1754 41.7082 64.2324 41.7082 64.371C41.7113 64.447 41.7326 64.5211 41.7701 64.5873C41.8079 64.6534 41.8608 64.7094 41.9247 64.7507C42.0443 64.821 42.1412 64.764 42.1412 64.6254ZM41.0608 64.0026C41.0572 63.9265 41.0356 63.8523 40.9976 63.7862C40.9596 63.7202 40.9064 63.6641 40.8424 63.6229C40.7227 63.5545 40.626 63.6095 40.626 63.7482C40.6294 63.8241 40.6508 63.898 40.6885 63.9641C40.7261 64.0301 40.7788 64.0862 40.8424 64.1279C40.9734 64.1962 41.0608 64.1431 41.0608 64.0026ZM39.9784 63.3836C39.975 63.3076 39.9535 63.2337 39.9159 63.1676C39.8782 63.1017 39.8255 63.0455 39.762 63.0038C39.6423 62.9355 39.5455 62.9924 39.5455 63.1291C39.549 63.2051 39.5704 63.2791 39.608 63.345C39.6456 63.4111 39.6984 63.4673 39.762 63.5089C39.8815 63.5735 39.9784 63.5165 39.9784 63.3836Z",
    fill: "#DFE4F4"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M48.914 57.4654L39.7351 62.7649L39.944 62.8865L49.1229 57.5868L48.914 57.4654ZM61.883 64.9543L52.704 70.2539L52.9129 70.3735L62.0919 65.074L61.883 64.9543ZM57.5593 62.4574L48.3785 67.7513L48.5874 67.8728L57.7682 62.5732L57.5593 62.4574ZM55.4041 61.2098L46.2253 66.5094L46.4342 66.631L55.613 61.3313L55.4041 61.2098ZM46.7588 56.2178L38.9034 60.7522V60.9952L46.9677 56.3393L46.812 56.2483L46.7588 56.2178ZM59.7278 63.7049L50.547 69.0064L50.7578 69.126L59.9367 63.8263L59.7278 63.7049ZM44.0625 65.2619L44.2733 65.3815L53.4522 60.082L53.2434 59.9623L44.0625 65.2619ZM44.8068 55.09L44.7898 55.0804L44.5998 54.9703L38.9034 58.2572V58.4983L44.8068 55.09ZM51.0729 58.7129L41.8941 64.0144L42.1029 64.134L51.2857 58.8268L51.0729 58.7129ZM64.0439 66.2018L54.863 71.5014L55.0719 71.623L64.2526 66.3233L64.2204 66.3043L64.0439 66.2018Z",
    fill: "#F6F6FB"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M41.6657 64.8007V63.8797L38.8972 62.2809V63.2246L41.6657 64.8007Z",
    fill: "url(#paint25_linear_722_15716)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M56.7086 61.9428L43.0617 54.0626L39.7159 55.9937C39.4784 56.1489 39.2807 56.3579 39.1389 56.6036C38.997 56.8494 38.915 57.1251 38.8995 57.4084V62.2827L41.6623 63.8777H55.3338L56.9763 62.9283C57.0273 62.9037 57.0695 62.8637 57.0967 62.814C57.124 62.7643 57.135 62.7074 57.1282 62.6511C57.1196 62.5082 57.077 62.3692 57.0041 62.2461C56.9311 62.1229 56.8298 62.0189 56.7086 61.9428Z",
    fill: "url(#paint26_linear_722_15716)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M47.0495 61.6755H46.8786C45.7185 61.6755 44.3 61.9299 43.7304 62.2811C43.6545 62.3267 43.6582 62.4064 43.7893 62.6097C43.981 62.8383 44.2167 63.0262 44.4823 63.1622C44.9295 63.3166 45.4011 63.3887 45.8742 63.3749H47.0495V61.6755Z",
    fill: "url(#paint27_linear_722_15716)"
  }), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1364 59.8052V60.5648C43.9218 60.4413 43.7567 60.542 43.7567 60.7888V61.5674C43.7629 61.7015 43.8005 61.8324 43.8664 61.9494C43.9324 62.0665 44.0248 62.1665 44.1364 62.2414C44.3509 62.3649 44.5161 62.2642 44.5161 62.0155V61.2445L45.1769 61.6243V62.3952C45.1769 63.0655 44.708 63.3446 44.1269 63.001C43.8215 62.8019 43.5675 62.5336 43.3854 62.2178C43.2032 61.9021 43.0982 61.5478 43.0787 61.1838V60.4053C43.0882 59.7425 43.5572 59.471 44.1364 59.8052Z",
    fill: "#BBC0E6"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1368 60.5673L44.9496 60.0983V60.8805C44.9507 60.9181 44.9545 60.9556 44.961 60.9926L44.5224 61.247V62.018C44.5224 62.2667 44.3476 62.3674 44.1426 62.2439C44.0311 62.1691 43.9386 62.0691 43.8727 61.9519C43.8067 61.8349 43.7691 61.704 43.7628 61.5699V60.7913C43.7496 60.5445 43.9223 60.4438 44.1368 60.5673Z",
    fill: "url(#paint28_linear_722_15716)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0886 60.4108V61.1893C43.1081 61.5533 43.2131 61.9076 43.3953 62.2233C43.5773 62.5391 43.8314 62.8074 44.1368 63.0065C44.7178 63.3426 45.1869 63.071 45.1869 62.4008V61.6241C45.1672 61.2597 45.0619 60.905 44.8795 60.589C44.6969 60.2729 44.4426 60.0043 44.1368 59.8051C43.5577 59.4709 43.0886 59.7424 43.0886 60.4108ZM43.7494 60.7905C43.7494 60.5437 43.9223 60.4431 44.1291 60.5664C44.2407 60.6414 44.3332 60.7414 44.3992 60.8584C44.465 60.9755 44.5027 61.1063 44.509 61.2406V62.0171C44.509 62.2659 44.3342 62.3666 44.1291 62.2431C44.0177 62.1683 43.9251 62.0683 43.8592 61.9512C43.7932 61.8342 43.7556 61.7033 43.7494 61.569V60.7905Z",
    fill: "#CED3F8"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8794 63.0809L44.9041 63.0658C45.0027 62.9872 45.0802 62.8853 45.1296 62.7693C45.1789 62.6532 45.1987 62.5267 45.187 62.4011V61.6246C45.1674 61.2601 45.062 60.9055 44.8796 60.5894C44.6971 60.2733 44.4427 60.0048 44.137 59.8055C44.034 59.7331 43.9148 59.6873 43.7899 59.6724C43.6648 59.6575 43.5382 59.6739 43.4211 59.72L44.5851 59.0478L44.6193 59.027C44.7367 58.9807 44.8638 58.9645 44.9892 58.9797C45.1145 58.995 45.234 59.0412 45.337 59.1143C45.6425 59.3134 45.8968 59.5817 46.0792 59.8973C46.2616 60.2131 46.3672 60.5674 46.3871 60.9315V61.71C46.4007 61.8404 46.3795 61.9721 46.3255 62.0916C46.2713 62.211 46.1864 62.3139 46.0794 62.3898L44.8737 63.0847L44.8794 63.0809Z",
    fill: "url(#paint29_linear_722_15716)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M43.345 59.0161L43.9355 58.399L44.5165 58.7351L45.0994 60.0301L44.4633 59.6618L44.1368 58.9895L43.8329 59.2991L43.345 59.0161Z",
    fill: "#CED3F8"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0993 60.0244L44.5164 58.7294L45.722 58.0269L46.305 59.3219L45.0993 60.0244Z",
    fill: "#BBC0E6"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5162 58.7284L43.9352 58.3923L45.141 57.6898L45.722 58.0259L44.5162 58.7284Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M56.5022 63.0375L53.561 61.3476C53.2686 61.1766 51.9432 61.1766 51.6488 61.3476L48.7076 63.0375C48.4152 63.2065 48.4152 63.4818 48.7076 63.6527L51.4627 65.2344V65.4718H53.0275C53.213 65.4756 53.3965 65.4325 53.561 65.3464L56.5022 63.6565C56.7947 63.4837 56.7947 63.2065 56.5022 63.0375Z",
    fill: "url(#paint30_linear_722_15716)"
  }), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9953 64.423C51.8298 64.5063 51.6471 64.5497 51.4618 64.5497C51.2764 64.5497 51.0937 64.5063 50.9282 64.423L47.987 62.733C47.6944 62.5641 47.6944 62.2868 47.987 62.1178L50.9282 60.4279C51.0937 60.3446 51.2764 60.3012 51.4618 60.3012C51.6471 60.3012 51.8298 60.3446 51.9953 60.4279L54.9348 62.1178C55.2291 62.2868 55.2291 62.5641 54.9348 62.733L51.9953 64.423Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9874 62.7334L50.9287 64.4233C51.0942 64.5066 51.277 64.55 51.4623 64.55C51.6476 64.55 51.8303 64.5066 51.9958 64.4233L54.9372 62.7334C54.9929 62.708 55.0417 62.6697 55.0794 62.6214C55.117 62.5731 55.1425 62.5164 55.1536 62.4562V63.3163C55.1555 63.3347 55.1555 63.3531 55.1536 63.3714C55.1418 63.4315 55.116 63.4882 55.0784 63.5367C55.0408 63.5851 54.9924 63.6241 54.9372 63.6505L51.9958 65.3405C51.8303 65.4238 51.6476 65.4672 51.4623 65.4672C51.277 65.4672 51.0942 65.4238 50.9287 65.3405L47.9874 63.6505C47.9266 63.6223 47.8744 63.5784 47.836 63.5233C47.7976 63.4682 47.7745 63.4041 47.769 63.3372V62.4334C47.7767 62.4979 47.8009 62.5593 47.8391 62.6119C47.8774 62.6644 47.9284 62.7062 47.9874 62.7334Z",
    fill: "url(#paint31_linear_722_15716)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9203 61.7172L51.743 62.3989C51.8782 62.4727 52.0318 62.5063 52.1854 62.4958C52.3392 62.492 52.4897 62.4509 52.6241 62.3761C52.8026 62.2736 52.8804 62.1559 52.8595 62.0248L53.2564 62.0343C53.2564 62.2356 53.1368 62.4141 52.8767 62.5565C52.6085 62.71 52.2993 62.7764 51.9917 62.7464C52.0221 62.9477 51.9063 63.1243 51.6443 63.2761C51.4703 63.3757 51.2749 63.4317 51.0746 63.4395C50.8844 63.4576 50.6932 63.4179 50.5259 63.3255C50.3721 63.2363 50.3151 63.1356 50.355 63.0312C50.435 62.8837 50.5611 62.7664 50.7139 62.6971L51.1506 62.435L51.0804 62.3951C50.979 62.3354 50.8629 62.3055 50.7452 62.3089C50.6277 62.3122 50.5135 62.3487 50.4157 62.4141C50.2747 62.4909 50.168 62.6186 50.1176 62.771L49.7626 62.7369C49.7917 62.6263 49.8448 62.5235 49.918 62.4356C49.991 62.3477 50.0826 62.2769 50.186 62.228C50.4099 62.092 50.6711 62.0302 50.9322 62.0514C50.9322 61.8844 51.0385 61.7381 51.2512 61.6129C51.475 61.489 51.7265 61.4237 51.9823 61.4229C52.2446 61.4145 52.5038 61.4804 52.7304 61.6129L52.9203 61.7172ZM51.5019 62.6477L51.4069 62.5926L51.0367 62.8148C50.8468 62.9211 50.7689 63.0046 50.788 63.0559C50.8034 63.089 50.8303 63.1154 50.8638 63.13C50.9443 63.1759 51.0379 63.194 51.1296 63.1812C51.2392 63.1667 51.3445 63.1299 51.4392 63.073C51.4838 63.053 51.5237 63.024 51.5564 62.9876C51.5891 62.9513 51.6138 62.9086 51.629 62.8622C51.6443 62.7749 51.6064 62.7046 51.5019 62.6477ZM51.9272 61.6679C51.7938 61.6714 51.6633 61.7078 51.5474 61.7742C51.5014 61.7969 51.4606 61.8292 51.4279 61.8688C51.3952 61.9084 51.3712 61.9544 51.3575 62.0039C51.3385 62.0932 51.3822 62.1749 51.4886 62.2471L52.3354 61.7628C52.2091 61.6992 52.0685 61.669 51.9272 61.6755V61.6679Z",
    fill: "#807DFB"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2661 64.5775C85.434 65.2516 85.434 66.3548 84.2661 67.0289L71.3542 74.4818C70.1864 75.1558 68.2743 75.1558 67.1065 74.4818L54.1945 67.0289C53.0268 66.3548 53.0268 65.2516 54.1945 64.5775L67.1065 57.1247C68.2743 56.4505 70.1864 56.4505 71.3542 57.1247L84.2661 64.5775Z",
    fill: "#E0E7FF"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2658 67.0293L71.3538 74.4822C70.186 75.1563 68.2739 75.1563 67.1061 74.4822L54.1942 67.0293C53.6112 66.6932 53.3187 66.249 53.3187 65.8027V75.4259C53.3187 75.8703 53.6112 76.3146 54.1942 76.6526L67.1061 84.1055C68.2739 84.7795 70.186 84.7795 71.3538 84.1055L84.2658 76.6526C84.8354 76.3184 85.1373 75.8778 85.1411 75.4354V65.8141C85.1354 66.2546 84.8354 66.6952 84.2658 67.0293Z",
    fill: "url(#paint32_linear_722_15716)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M98.1525 63.0969L99.5671 62.2805V57.4062C99.5519 57.1228 99.47 56.847 99.3281 56.6012C99.1863 56.3554 98.9884 56.1466 98.7506 55.9915L95.4258 54.0795L88.9697 57.8049L98.1525 63.0969Z",
    fill: "url(#paint33_linear_722_15716)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M63.839 43.2897L65.2556 42.4732V37.5989C65.24 37.3154 65.1578 37.0395 65.0155 36.7937C64.8734 36.5479 64.6752 36.3392 64.4372 36.1843L61.1123 34.2646L54.6564 37.9901L63.839 43.2897Z",
    fill: "url(#paint34_linear_722_15716)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M74.6458 43.2759L73.2312 42.4594V37.5852C73.2462 37.3015 73.3281 37.0253 73.4699 36.7793C73.6118 36.5331 73.8098 36.3239 74.0477 36.1687L77.3726 34.2509L83.8285 37.9764L74.6458 43.2759Z",
    fill: "url(#paint35_linear_722_15716)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M40.3118 63.0989L38.8972 62.2824V57.4081C38.9127 57.1248 38.9948 56.8491 39.1366 56.6033C39.2784 56.3576 39.4761 56.1487 39.7137 55.9935L43.0386 54.0795L49.4945 57.8049L40.3118 63.0989Z",
    fill: "url(#paint36_linear_722_15716)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M58.1613 75.1191L59.7165 77.8127L58.3977 78.5741L56.8425 75.8805L58.1613 75.1191Z",
    fill: "url(#paint37_linear_722_15716)"
  }), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7843 75.0401L56.9047 74.3925C57.0054 74.346 57.1169 74.3273 57.2274 74.3383C57.3379 74.3494 57.4434 74.3897 57.5332 74.4552C57.7926 74.6244 58.0084 74.8523 58.1631 75.1206C58.3178 75.3887 58.4071 75.6897 58.4237 75.9989C58.4344 76.1084 58.4159 76.2187 58.3702 76.3187C58.3245 76.4187 58.2533 76.5049 58.1635 76.5686L57.0433 77.2161L55.7843 75.0401Z",
    fill: "url(#paint38_linear_722_15716)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5203 75.6174C55.5372 75.9263 55.6267 76.227 55.7814 76.4948C55.9361 76.7627 56.1518 76.9903 56.4109 77.1594C56.4962 77.2341 56.6029 77.2803 56.7158 77.2914C56.8288 77.3025 56.9423 77.2779 57.0406 77.2212C57.1389 77.1644 57.2168 77.0783 57.2637 76.9748C57.3104 76.8715 57.3236 76.756 57.3015 76.6447C57.2846 76.3358 57.1952 76.0353 57.0404 75.7674C56.8857 75.4995 56.6701 75.2719 56.4109 75.1029C56.3256 75.0281 56.2189 74.9819 56.106 74.9708C55.993 74.9598 55.8795 74.9842 55.7813 75.0411C55.6829 75.0978 55.605 75.184 55.5583 75.2873C55.5114 75.3908 55.4982 75.5062 55.5203 75.6174Z",
    fill: "#F6F6FB"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M61.5714 77.0991L63.1265 79.7926L61.8077 80.554L60.2526 77.8604L61.5714 77.0991Z",
    fill: "url(#paint39_linear_722_15716)"
  }), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2018 77.0183L60.3222 76.3708C60.4229 76.3242 60.5344 76.3055 60.6449 76.3166C60.7555 76.3276 60.861 76.3679 60.9507 76.4334C61.2097 76.6024 61.4254 76.8301 61.5801 77.0979C61.7349 77.3658 61.8244 77.6664 61.8412 77.9752C61.8518 78.0847 61.8334 78.195 61.7877 78.295C61.7419 78.3951 61.6708 78.4813 61.5811 78.5449L60.4607 79.1924L59.2018 77.0183Z",
    fill: "url(#paint40_linear_722_15716)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9326 77.595C58.9492 77.9042 59.0385 78.2051 59.1932 78.4733C59.348 78.7416 59.5638 78.9695 59.8232 79.1386C59.9085 79.2135 60.0152 79.2597 60.1281 79.2708C60.241 79.2819 60.3545 79.2573 60.4529 79.2005C60.5511 79.1438 60.6292 79.0576 60.6759 78.9542C60.7227 78.8508 60.7359 78.7353 60.7137 78.6241C60.6971 78.3151 60.6078 78.0145 60.4531 77.7466C60.2984 77.4786 60.0825 77.251 59.8232 77.0823C59.7379 77.0077 59.6316 76.9616 59.5189 76.9506C59.4062 76.9395 59.2929 76.9639 59.1947 77.0204C59.0966 77.0769 59.0186 77.1626 58.9716 77.2656C58.9246 77.3687 58.911 77.4838 58.9326 77.595Z",
    fill: "#80AAFF"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M64.9849 79.0773L66.5401 81.7708L65.2213 82.5323L63.6661 79.8387L64.9849 79.0773Z",
    fill: "url(#paint41_linear_722_15716)"
  }), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6062 78.9951L63.7266 78.3476C63.8273 78.3011 63.9388 78.2824 64.0493 78.2934C64.1599 78.3044 64.2655 78.3448 64.3551 78.4103C64.6144 78.579 64.8303 78.8066 64.985 79.0746C65.1397 79.3425 65.229 79.6431 65.2456 79.9521C65.2562 80.0616 65.2378 80.1719 65.1921 80.2719C65.1464 80.372 65.0752 80.4581 64.9854 80.5218L63.8652 81.1674L62.6062 78.9951Z",
    fill: "url(#paint42_linear_722_15716)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3443 79.574C62.3609 79.883 62.4502 80.1836 62.605 80.4516C62.7597 80.7195 62.9755 80.9471 63.2349 81.1158C63.3201 81.1903 63.4265 81.2364 63.5392 81.2475C63.6519 81.2586 63.7652 81.2342 63.8633 81.1777C63.9615 81.1212 64.0395 81.0354 64.0864 80.9324C64.1335 80.8294 64.147 80.7143 64.1255 80.6032C64.1086 80.294 64.0191 79.9932 63.8644 79.725C63.7097 79.4568 63.494 79.2288 63.2349 79.0594C63.1496 78.9846 63.0429 78.9384 62.93 78.9274C62.817 78.9162 62.7035 78.9408 62.6052 78.9975C62.5069 79.0544 62.429 79.1405 62.3821 79.2439C62.3354 79.3472 62.3222 79.4627 62.3443 79.574Z",
    fill: "#F6F6FB"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M58.1613 70.9399L59.7165 73.6335L58.3977 74.3949L56.8425 71.7014L58.1613 70.9399Z",
    fill: "url(#paint43_linear_722_15716)"
  }), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7843 70.8577L56.9047 70.2102C57.0054 70.1636 57.1169 70.145 57.2274 70.156C57.3379 70.167 57.4434 70.2074 57.5332 70.2729C57.7922 70.4418 58.0079 70.6695 58.1626 70.9374C58.3173 71.2053 58.4068 71.5058 58.4237 71.8148C58.4344 71.9242 58.4159 72.0344 58.3702 72.1345C58.3245 72.2345 58.2533 72.3207 58.1635 72.3844L57.0433 73.0319L55.7843 70.8577Z",
    fill: "url(#paint44_linear_722_15716)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5199 71.4344C55.5366 71.7436 55.6258 72.0445 55.7806 72.3128C55.9353 72.581 56.1511 72.809 56.4105 72.9782C56.4958 73.0529 56.6024 73.0991 56.7153 73.1102C56.8283 73.1213 56.9419 73.0967 57.0401 73.0399C57.1384 72.9832 57.2164 72.8971 57.2632 72.7936C57.3099 72.6903 57.3232 72.5749 57.301 72.4635C57.2845 72.1545 57.1951 71.8539 57.0403 71.586C56.8856 71.318 56.6698 71.0905 56.4105 70.9217C56.3253 70.8472 56.2188 70.8012 56.1061 70.79C55.9935 70.7789 55.8801 70.8034 55.782 70.8598C55.6838 70.9163 55.6059 71.002 55.5588 71.1051C55.5119 71.2081 55.4983 71.3232 55.5199 71.4344Z",
    fill: "#80AAFF"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M61.5714 72.9198L63.1265 75.6133L61.8077 76.3748L60.2526 73.6811L61.5714 72.9198Z",
    fill: "url(#paint45_linear_722_15716)"
  }), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2018 72.836L60.3222 72.1884C60.4229 72.142 60.5344 72.1232 60.6449 72.1342C60.7555 72.1452 60.861 72.1856 60.9507 72.2511C61.21 72.4199 61.4258 72.6475 61.5806 72.9154C61.7353 73.1834 61.8246 73.484 61.8412 73.793C61.8518 73.9024 61.8334 74.0128 61.7877 74.1128C61.7419 74.2127 61.6708 74.2989 61.5811 74.3626L60.4607 75.0082L59.2018 72.836Z",
    fill: "url(#paint46_linear_722_15716)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9317 73.4135C58.9482 73.7224 59.0375 74.0231 59.1923 74.2911C59.347 74.5589 59.5629 74.7866 59.8221 74.9553C59.9074 75.0298 60.0138 75.0759 60.1264 75.087C60.2391 75.0981 60.3524 75.0736 60.4507 75.0171C60.5488 74.9606 60.6267 74.8749 60.6738 74.7719C60.7207 74.6689 60.7344 74.5538 60.7127 74.4427C60.6958 74.1335 60.6064 73.8326 60.4517 73.5644C60.2969 73.2963 60.0813 73.0683 59.8221 72.8989C59.7368 72.8241 59.6302 72.7778 59.5173 72.7668C59.4044 72.7557 59.2907 72.7803 59.1925 72.837C59.0943 72.8939 59.0162 72.9799 58.9695 73.0834C58.9227 73.1867 58.9094 73.3022 58.9317 73.4135Z",
    fill: "#F6F6FB"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M64.9857 74.895L66.5408 77.5886L65.222 78.35L63.6669 75.6565L64.9857 74.895Z",
    fill: "url(#paint47_linear_722_15716)"
  }), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6062 74.8139L63.7266 74.1683C63.8273 74.1218 63.9388 74.1031 64.0493 74.1141C64.1599 74.1251 64.2655 74.1655 64.3551 74.231C64.6144 74.3997 64.8303 74.6273 64.985 74.8952C65.1397 75.1632 65.229 75.4638 65.2456 75.7728C65.2562 75.8822 65.2378 75.9926 65.1921 76.0926C65.1464 76.1926 65.0752 76.2788 64.9854 76.3425L63.8652 76.9899L62.6062 74.8139Z",
    fill: "url(#paint48_linear_722_15716)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3443 75.3918C62.3609 75.7008 62.4502 76.0014 62.605 76.2693C62.7597 76.5373 62.9755 76.7648 63.2349 76.9336C63.3202 77.0084 63.4269 77.0546 63.5398 77.0657C63.6528 77.0767 63.7663 77.0522 63.8645 76.9954C63.9629 76.9387 64.0408 76.8525 64.0877 76.7492C64.1344 76.6457 64.1476 76.5303 64.1255 76.419C64.1086 76.1102 64.0191 75.8095 63.8644 75.5417C63.7097 75.2738 63.494 75.0462 63.2349 74.8771C63.1496 74.8024 63.0429 74.7562 62.93 74.7451C62.817 74.734 62.7035 74.7586 62.6052 74.8153C62.5069 74.8721 62.429 74.9582 62.3821 75.0617C62.3354 75.165 62.3222 75.2804 62.3443 75.3918Z",
    fill: "#80AAFF"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M108.432 63.4971C108.508 63.4596 108.591 63.4401 108.675 63.4401C108.759 63.4401 108.842 63.4596 108.917 63.4971C108.946 63.5073 108.97 63.5262 108.988 63.5511C109.006 63.5762 109.015 63.606 109.015 63.6365C109.015 63.6671 109.006 63.6971 108.988 63.722C108.97 63.747 108.946 63.7659 108.917 63.7761C108.842 63.8145 108.759 63.8345 108.675 63.8345C108.59 63.8345 108.507 63.8145 108.432 63.7761C108.404 63.7659 108.379 63.747 108.361 63.722C108.343 63.6971 108.334 63.6671 108.334 63.6365C108.334 63.606 108.343 63.5762 108.361 63.5511C108.379 63.5262 108.404 63.5073 108.432 63.4971Z",
    fill: "url(#paint49_linear_722_15716)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M107.411 61.2943C107.417 61.2003 107.444 61.1089 107.491 61.0275C107.538 60.9461 107.604 60.8768 107.683 60.8253C107.833 60.7378 107.954 60.8081 107.954 60.981C107.949 61.075 107.922 61.1665 107.875 61.248C107.828 61.3296 107.762 61.3987 107.683 61.4499C107.533 61.5373 107.411 61.467 107.411 61.2943Z",
    fill: "url(#paint50_linear_722_15716)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M108.675 63.831C108.658 63.8312 108.641 63.8281 108.625 63.8218C108.609 63.8153 108.595 63.8059 108.582 63.7938C108.57 63.7818 108.561 63.7675 108.554 63.7518C108.547 63.736 108.544 63.719 108.544 63.7019V61.7689L107.551 61.1993C107.536 61.1907 107.523 61.1795 107.513 61.166C107.502 61.1526 107.495 61.1372 107.49 61.1208C107.486 61.1044 107.485 61.0873 107.487 61.0704C107.489 61.0536 107.495 61.0374 107.503 61.0227C107.521 60.9929 107.549 60.9709 107.583 60.9617C107.616 60.9526 107.651 60.9567 107.682 60.9733L108.739 61.5847C108.759 61.5964 108.776 61.613 108.787 61.6331C108.798 61.653 108.804 61.6757 108.804 61.6986V63.7056C108.804 63.7224 108.8 63.7389 108.794 63.7542C108.787 63.7696 108.777 63.7835 108.765 63.7951C108.753 63.8067 108.739 63.8159 108.724 63.8221C108.708 63.8282 108.692 63.8312 108.675 63.831Z",
    fill: "url(#paint51_linear_722_15716)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M117.773 58.1036C117.848 58.0652 117.93 58.0453 118.014 58.0453C118.098 58.0453 118.181 58.0652 118.255 58.1036C118.39 58.1795 118.39 58.3048 118.255 58.3826C118.181 58.4201 118.098 58.4396 118.014 58.4396C117.93 58.4396 117.848 58.4201 117.773 58.3826C117.638 58.3048 117.638 58.1795 117.773 58.1036Z",
    fill: "url(#paint52_linear_722_15716)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M116.75 55.9042C116.756 55.8104 116.783 55.7191 116.829 55.6377C116.876 55.5563 116.942 55.4869 117.02 55.4351C117.17 55.3497 117.291 55.42 117.291 55.5927C117.286 55.6867 117.259 55.7782 117.212 55.8597C117.165 55.9411 117.099 56.0104 117.02 56.0618C116.872 56.1472 116.75 56.0769 116.75 55.9042Z",
    fill: "url(#paint53_linear_722_15716)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M118.014 58.4459C117.98 58.4459 117.946 58.4321 117.922 58.4076C117.897 58.3831 117.883 58.3497 117.883 58.3149V56.3781L116.89 55.8086C116.861 55.7908 116.839 55.7622 116.831 55.7288C116.822 55.6956 116.826 55.6602 116.843 55.63C116.86 55.6001 116.889 55.5784 116.922 55.5695C116.956 55.5606 116.991 55.5653 117.021 55.5825L118.079 56.194C118.099 56.2051 118.116 56.2213 118.127 56.241C118.139 56.2607 118.145 56.2832 118.145 56.306V58.313C118.146 58.3305 118.142 58.3477 118.136 58.3637C118.13 58.3799 118.12 58.3945 118.108 58.4069C118.095 58.4193 118.081 58.4291 118.065 58.4358C118.049 58.4425 118.032 58.4459 118.014 58.4459Z",
    fill: "url(#paint54_linear_722_15716)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M30.1502 60.9666L23.1245 56.9032C22.9615 56.7858 22.8282 56.6319 22.7353 56.4539C22.6423 56.2759 22.5922 56.0786 22.589 55.8778V52.7675C22.589 52.3726 22.8301 52.1978 23.1245 52.3631L30.0418 56.3563L30.021 55.9557L30.5128 56.8082C30.6284 57.0016 30.6937 57.221 30.7026 57.4462V60.5565C30.6932 60.9571 30.452 61.1376 30.1502 60.9666Z",
    fill: "url(#paint55_linear_722_15716)"
  }), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1739 55.8848L22.1331 51.8194C21.8369 51.6484 21.5977 51.8194 21.5977 52.2238V55.3341C21.6006 55.535 21.6505 55.7324 21.7435 55.9105C21.8365 56.0885 21.97 56.2423 22.1331 56.3595L29.1739 60.423C29.4702 60.5938 29.7094 60.4134 29.7094 60.0185V56.9083C29.7064 56.7076 29.6565 56.5105 29.5635 56.3328C29.4705 56.1549 29.3371 56.0016 29.1739 55.8848Z",
    fill: "#DAE0F5"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M22.589 55.9793L28.7184 59.5187V56.2659L22.589 52.7265V55.9793Z",
    fill: "#6B67E9"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M29.523 60.4492C29.5896 60.4007 29.6423 60.3355 29.6757 60.2601C29.709 60.1848 29.7218 60.102 29.7128 60.02V56.9098C29.7099 56.7092 29.6599 56.5121 29.5669 56.3343C29.4739 56.1565 29.3404 56.0031 29.1774 55.8863L22.1327 51.8209C22.0843 51.7869 22.0279 51.766 21.9689 51.7604C21.91 51.7548 21.8507 51.7644 21.7966 51.7887L22.3017 51.4982C22.3554 51.4747 22.4141 51.4656 22.4724 51.4716C22.5306 51.4776 22.5863 51.4985 22.634 51.5323L29.6749 55.5996C29.838 55.7168 29.9714 55.8705 30.0644 56.0486C30.1574 56.2267 30.2073 56.4241 30.2103 56.625V59.7353C30.2189 59.8159 30.2069 59.8974 30.1753 59.9722C30.1438 60.0469 30.0938 60.1123 30.0299 60.1625L29.523 60.4549V60.4492Z",
    fill: "url(#paint56_linear_722_15716)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6542 55.3951L23.058 55.0496V55.7388L23.6542 56.0825V55.3951ZM26.4474 55.6116L25.8512 55.2679V55.9553L26.4474 56.3008V55.6116Z",
    fill: "#5652CC"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8107 57.17L26.7872 56.5795V57.7606L27.8107 58.3511V57.17Z",
    fill: "#807DFB"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2543 54.9246L24.0182 54.2107V55.6386L25.2543 56.3526V54.9246Z",
    fill: "#362E94"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M107.925 54.5645L107.439 54.8437V58.4097L107.925 58.6887V54.5645Z",
    fill: "#A1A7CE"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M107.925 58.6904L107.439 58.4114V58.9715L107.925 58.6904Z",
    fill: "#CCD1F6"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M109.093 53.8904L108.607 54.1695V57.7355L109.093 58.0147V53.8904Z",
    fill: "#A1A7CE"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M109.093 58.0148L108.607 57.7356V58.2957L109.093 58.0148Z",
    fill: "#CCD1F6"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M110.261 53.2177L109.775 53.4988V57.0629L110.261 57.3419V53.2177Z",
    fill: "#A1A7CE"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M110.261 57.342L109.775 57.0629V57.6231L110.261 57.342Z",
    fill: "#CCD1F6"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M111.426 52.542L110.942 52.8212V56.3872L111.426 56.6663V52.542Z",
    fill: "#A1A7CE"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M111.426 56.6679L110.942 56.3887V56.949L111.426 56.6679Z",
    fill: "#CCD1F6"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M112.595 51.8693L112.109 52.1503V55.7144L112.595 55.9936V51.8693Z",
    fill: "#A1A7CE"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M112.595 55.9938L112.109 55.7146V56.2747L112.595 55.9938Z",
    fill: "#CCD1F6"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M113.762 51.1937L113.276 51.4747V55.0388L113.762 55.3198V51.1937Z",
    fill: "#A1A7CE"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M113.762 55.3215L113.276 55.0405V55.6007L113.762 55.3215Z",
    fill: "#CCD1F6"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M114.93 50.5195L114.444 50.8006V54.3647L114.93 54.6456V50.5195Z",
    fill: "#A1A7CE"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M114.93 54.6457L114.444 54.3647V54.9249L114.93 54.6457Z",
    fill: "#CCD1F6"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M116.096 49.8468L115.612 50.1279V53.692L116.096 53.973V49.8468Z",
    fill: "#A1A7CE"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M116.096 53.9731L115.612 53.692V54.2523L116.096 53.9731Z",
    fill: "#CCD1F6"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M117.265 49.1711L116.78 49.4521V53.0162L117.265 53.2973V49.1711Z",
    fill: "#A1A7CE"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M117.265 53.3004L116.78 53.0193V53.5796L117.265 53.3004Z",
    fill: "#CCD1F6"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M80.3714 25.4645L72.0641 20.6681C71.8991 20.5759 71.7238 20.5033 71.5419 20.4517L78.7916 24.6291C79.1865 24.8569 79.3841 25.1588 79.3841 25.4589V26.281C79.3841 26.5811 79.1942 26.883 78.7916 27.1108L70.6685 31.801C70.2687 32.0141 69.8244 32.1298 69.3716 32.139H70.6476C71.2046 32.1761 71.761 32.0592 72.2559 31.801L80.3714 27.1146C81.1613 26.6665 81.1613 25.9203 80.3714 25.4645Z",
    fill: "url(#paint57_linear_722_15716)"
  }), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4906 24.5329C58.7007 24.9886 58.7007 25.7348 59.4906 26.1905L67.7961 30.9869C68.2415 31.2116 68.7336 31.3286 69.2325 31.3286C69.7315 31.3286 70.2234 31.2116 70.669 30.9869L78.9744 26.1905C79.7643 25.7348 79.7643 24.9886 78.9744 24.5329L70.669 19.7364C70.2234 19.5118 69.7315 19.3947 69.2325 19.3947C68.7336 19.3947 68.2415 19.5118 67.7961 19.7364L59.4906 24.5329Z",
    fill: "white"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5669 25.3608C79.5669 25.6627 79.3769 25.9627 78.9744 26.1906L70.669 30.987C70.2235 31.2117 69.7315 31.3287 69.2326 31.3287C68.7336 31.3287 68.2415 31.2117 67.7961 30.987L59.4906 26.1906C59.0956 25.9627 58.8982 25.6646 58.8982 25.3646V26.183C58.8982 26.483 59.0881 26.7811 59.4906 27.009L67.7961 31.8054C68.2415 32.0301 68.7336 32.1471 69.2326 32.1471C69.7315 32.1471 70.2235 32.0301 70.669 31.8054L78.9744 27.009C79.3694 26.7811 79.5669 26.4811 79.5669 26.1792V25.357V25.3608Z",
    fill: "url(#paint58_linear_722_15716)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M45.6141 45.6517L37.3068 40.8552C37.1417 40.763 36.9664 40.6904 36.7846 40.6388L44.0342 44.8162C44.4292 45.0441 44.6267 45.3459 44.6267 45.6459V46.4833C44.6267 46.7853 44.4369 47.0853 44.0342 47.3131L35.9111 51.99C35.5114 52.2031 35.0671 52.3189 34.6143 52.3279H35.8902C36.4472 52.3659 37.0039 52.2489 37.4985 51.99L45.6216 47.3017C46.404 46.8631 46.404 46.1036 45.6141 45.6517Z",
    fill: "url(#paint59_linear_722_15716)"
  }), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7327 44.7198C23.9428 45.1755 23.9428 45.9217 24.7327 46.3775L33.0382 51.1739C33.4836 51.3985 33.9757 51.5157 34.4746 51.5157C34.9736 51.5157 35.4656 51.3985 35.911 51.1739L44.2165 46.3775C45.0064 45.9217 45.0064 45.1755 44.2165 44.7198L35.911 39.9233C35.4656 39.6987 34.9736 39.5817 34.4746 39.5817C33.9757 39.5817 33.4836 39.6987 33.0382 39.9233L24.7327 44.7198Z",
    fill: "white"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8089 45.5497C44.8089 45.8498 44.619 46.1498 44.2165 46.3777L35.911 51.1741C35.4655 51.3987 34.9736 51.5157 34.4746 51.5157C33.9757 51.5157 33.4836 51.3987 33.0382 51.1741L24.7327 46.3777C24.3377 46.1517 24.1403 45.8517 24.1403 45.5516V46.37C24.1403 46.6701 24.3301 46.9701 24.7327 47.1961L33.0382 51.9906C33.4836 52.2152 33.9757 52.3322 34.4746 52.3322C34.9736 52.3322 35.4655 52.2152 35.911 51.9906L44.2165 47.1941C44.6115 46.9663 44.8089 46.6662 44.8089 46.3662V45.5441V45.5497Z",
    fill: "url(#paint60_linear_722_15716)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M80.3714 65.0929L72.066 60.2983C71.9006 60.205 71.7247 60.1317 71.5419 60.08L78.7917 64.2573C79.1865 64.4852 79.3841 64.7871 79.3841 65.0872V65.9094C79.3841 66.2112 79.1942 66.5113 78.7917 66.7391L70.6685 71.4292C70.2687 71.6424 69.8244 71.7581 69.3716 71.7673H70.6476C71.2047 71.8062 71.7616 71.6891 72.2559 71.4292L80.3791 66.741C81.1613 66.2872 81.1613 65.541 80.3714 65.0929Z",
    fill: "url(#paint61_linear_722_15716)"
  }), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4906 64.1535C58.7007 64.6092 58.7007 65.3554 59.4906 65.8112L67.7961 70.6C68.2415 70.8246 68.7336 70.9416 69.2325 70.9416C69.7315 70.9416 70.2234 70.8246 70.669 70.6L78.9744 65.8054C79.7643 65.3478 79.7643 64.6016 78.9744 64.1459L70.669 59.3494C70.2234 59.1248 69.7315 59.0078 69.2325 59.0078C68.7336 59.0078 68.2415 59.1248 67.7961 59.3494L59.4906 64.1535Z",
    fill: "white"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5669 64.9828C79.5669 65.2829 79.3769 65.5829 78.9744 65.8127L70.669 70.5996C70.2235 70.8243 69.7315 70.9413 69.2326 70.9413C68.7336 70.9413 68.2415 70.8243 67.7961 70.5996L59.4906 65.8031C59.0956 65.5772 58.9001 65.2773 58.8982 64.9772V65.7956C58.8982 66.0956 59.0881 66.3956 59.4906 66.6215L67.7961 71.418C68.2415 71.6427 68.7336 71.7597 69.2326 71.7597C69.7315 71.7597 70.2235 71.6427 70.669 71.418L78.9744 66.6215C79.3694 66.3937 79.5669 66.0936 79.5669 65.7937V64.9715V64.9828Z",
    fill: "url(#paint62_linear_722_15716)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M114.684 45.2749L106.379 40.4804C106.214 40.3864 106.038 40.313 105.855 40.262L113.104 44.4395C113.499 44.6673 113.697 44.9692 113.697 45.2692V46.1047C113.697 46.4066 113.507 46.7066 113.104 46.9345L104.983 51.6113C104.583 51.8244 104.138 51.9403 103.684 51.9493H104.958C105.516 51.9884 106.074 51.8714 106.568 51.6113L114.69 46.9231C115.476 46.4844 115.474 45.7249 114.684 45.2749Z",
    fill: "url(#paint63_linear_722_15716)"
  }), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8039 44.3432C93.0121 44.7989 93.0121 45.5452 93.8039 46.0009L102.115 50.7972C102.561 51.0219 103.053 51.139 103.552 51.139C104.051 51.139 104.542 51.0219 104.988 50.7972L113.293 46.0028C114.083 45.5452 114.083 44.7989 113.293 44.3432L104.982 39.5467C104.537 39.322 104.045 39.205 103.546 39.205C103.047 39.205 102.555 39.322 102.109 39.5467L93.8039 44.3432Z",
    fill: "white"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M113.887 45.1734C113.887 45.4735 113.697 45.7735 113.295 46.0032L104.982 50.7977C104.536 51.0224 104.044 51.1395 103.545 51.1395C103.046 51.1395 102.554 51.0224 102.109 50.7977L93.8033 46.0014C93.4084 45.7753 93.2108 45.4754 93.2108 45.1753V45.9937C93.2108 46.2938 93.4007 46.5937 93.8033 46.8198L102.114 51.6123C102.56 51.837 103.052 51.9541 103.551 51.9541C104.05 51.9541 104.542 51.837 104.987 51.6123L113.293 46.816C113.688 46.5881 113.885 46.2881 113.885 45.988V45.1658L113.887 45.1734Z",
    fill: "url(#paint64_linear_722_15716)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M103.386 48.9039H102.181L98.3184 45.9778L106.299 41.3693L111.369 44.2954L103.386 48.9039Z",
    fill: "url(#paint65_linear_722_15716)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M69.072 29.0951H67.8662L64.004 26.169L71.9848 21.5606L77.0546 24.4867L69.072 29.0951Z",
    fill: "url(#paint66_linear_722_15716)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M34.314 49.2822H33.1083L29.2461 46.3561L37.2268 41.7476L42.2967 44.6737L34.314 49.2822Z",
    fill: "url(#paint67_linear_722_15716)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M69.072 68.7142H67.8662L64.004 65.7882L71.9867 61.1797L77.0546 64.1058L69.072 68.7142Z",
    fill: "url(#paint68_linear_722_15716)"
  }), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7218 63.4606L75.8434 63.3904L70.7849 60.4643L70.6634 60.5346L62.8022 65.0727L67.8721 67.9988L75.7218 63.4606Z",
    fill: "#012169"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0424 63.5132L74.0533 62.353L72.5779 61.5004L70.5689 62.6605L71.5657 60.9155L70.8006 60.475L69.158 63.3537L67.4662 62.3777L65.9928 63.2283L67.6826 64.2043L62.8806 65.1176L63.644 65.56L66.4845 65.0189L64.5972 66.1088L66.0705 66.9613L67.9599 65.8696L67.0219 67.5101L67.7871 67.9507L69.3707 65.1784L71.0607 66.1544L72.5361 65.3038L70.8461 64.3278L75.8287 63.3783L75.0653 62.9378L72.0424 63.5132Z",
    fill: "white"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7898 61.6251L69.2637 63.6607L67.2548 62.5005L66.2047 63.1062L68.2136 64.2664L64.8071 66.2335L65.8572 66.8392L69.2637 64.874L71.2726 66.0323L72.3227 65.4266L70.3138 64.2664L73.8398 62.2309L72.7898 61.6251Z",
    fill: "#E33C5C"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1203 60.6627L69.6867 63.1711L70.376 62.7723L71.4678 60.862L71.1203 60.6627ZM75.161 62.9944L71.8514 63.6249L71.1621 64.0217L75.5085 63.1939L75.161 62.9944ZM63.5478 65.5066L66.6752 64.9104L67.3645 64.5116L63.2003 65.3053L63.5478 65.5066ZM67.4651 67.7681L68.838 65.3642L68.1487 65.7611L67.1177 67.5668L67.4651 67.7681Z",
    fill: "#E33C5C"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7712 47.0302L33.1091 48.5663L28.0411 45.6403L30.7014 44.1041L35.7712 47.0302Z",
    fill: "#807DFB"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4306 45.4943L35.7703 47.0305L30.7004 44.1044L33.3607 42.5682L38.4306 45.4943Z",
    fill: "#F6F6FB"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0912 43.9583L38.4311 45.4944L33.3612 42.5684L36.0234 41.0322L41.0912 43.9583Z",
    fill: "#E33C5C"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M64.489 26.4278L62.7991 25.4537L70.7817 20.8452L72.4698 21.8193L64.489 26.4278Z",
    fill: "#20196F"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1782 27.4043L64.4883 26.4283L72.469 21.8199L74.159 22.7959L66.1782 27.4043Z",
    fill: "#E33C5C"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8664 28.3805L66.1783 27.4045L74.1591 22.7961L75.849 23.7721L67.8664 28.3805Z",
    fill: "#FFAF6D"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M102.18 48.1901L97.1117 45.264L105.092 40.6556L110.162 43.5816L102.18 48.1901Z",
    fill: "#E33C5C"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M100.146 45.4811L100.001 45.952L99.6104 45.5305L98.7881 45.595L99.3616 45.2494L99.0007 44.8203L99.7471 45.0273L100.345 44.6969L100.231 45.1697L100.962 45.3957L100.146 45.4811ZM101.633 44.0419L101.705 44.188L101.49 44.0988L101.27 44.1823L101.353 44.0381L101.145 43.9431H101.41L101.502 43.8007L101.583 43.945L101.847 43.9525L101.633 44.0419ZM102.422 44.5545L102.394 44.7064L102.254 44.5773L101.995 44.6095L102.164 44.4919L102.033 44.359L102.28 44.4159L102.457 44.3039L102.44 44.4557L102.679 44.5185L102.422 44.5545ZM102.369 45.2077L102.236 45.3406L102.198 45.1906L101.94 45.1583L102.176 45.0899L102.147 44.9381L102.333 45.0482L102.574 44.9855L102.451 45.1204L102.629 45.2324L102.369 45.2077ZM100.51 44.0172L100.689 44.1311L100.427 44.1045L100.294 44.2374L100.258 44.0855L99.9996 44.0532L100.235 43.9868L100.208 43.8349L100.393 43.9431L100.634 43.8824L100.51 44.0172Z",
    fill: "#FFAF6D"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M110.162 44.295L102.18 48.9035V48.1896L110.162 43.5811V44.295Z",
    fill: "#AA2141"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M102.18 48.9019L97.1117 45.9758V45.2618L102.18 48.1879V48.9019Z",
    fill: "#CE3459"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7702 47.7451L33.108 49.2813V48.5673L35.7702 47.0311V47.7451Z",
    fill: "#423EAF"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4307 46.2077L35.7704 47.7438V47.0298L38.4307 45.4937V46.2077Z",
    fill: "#CED3F8"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0901 44.6733L38.4298 46.2094V45.4955L41.0901 43.9594V44.6733Z",
    fill: "#AA2141"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1091 49.2801L28.0411 46.3541V45.6401L33.1091 48.5661V49.2801Z",
    fill: "#5652CC"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0599 66.8699L67.8661 68.7136V67.9997L71.0599 66.1559V66.8699ZM75.8487 64.1052L72.5352 66.0192V65.3053L75.8487 63.3913V64.1052Z",
    fill: "#0F3384"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2728 66.747L71.0601 66.8686V66.1547L71.2728 66.0312V66.747ZM72.5355 66.0178L72.3228 66.1413V65.4255L72.5355 65.3039V66.0178Z",
    fill: "#CED3F8"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3229 66.1419L71.2728 66.7476V66.0318L72.3229 65.426V66.1419Z",
    fill: "#AA2141"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M67.867 68.7122L67.7873 68.6666V67.9508L67.867 67.9982V68.7122ZM62.8807 65.8336L62.7991 65.7861V65.0721L62.8807 65.1177V65.8336Z",
    fill: "#1A346E"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7871 68.6668L67.4662 68.4807V67.7668L67.7871 67.951V68.6668ZM63.2015 66.018L62.8806 65.8338V65.1179L63.2015 65.3039V66.018ZM66.0705 67.6756L65.8579 67.5522V66.8383L66.0705 66.9616V67.6756ZM64.8079 66.9465L64.5972 66.8249V66.1091L64.8079 66.2326V66.9465Z",
    fill: "#CED3F8"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0213 68.2259L66.07 67.6771V66.9632L67.0213 67.5119V68.2259ZM64.5965 66.8265L63.6433 66.2758V65.5618L64.5965 66.1106V66.8265Z",
    fill: "#1A346E"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8572 67.5526L64.8071 66.9469V66.2329L65.8572 66.8386V67.5526Z",
    fill: "#C8102E"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1179 68.2814L67.021 68.2244V67.5105L67.1179 67.5655V68.2814ZM63.643 66.2743L63.548 66.2193V65.5053L63.643 65.5604V66.2743Z",
    fill: "#CED3F8"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4651 68.4807L67.1177 68.2813V67.5654L67.4651 67.7667V68.4807ZM63.5478 66.2192L63.2003 66.0178V65.3039L63.5478 65.5052V66.2192Z",
    fill: "#C8102E"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8487 24.4862L67.8661 29.0947V28.3807L75.8487 23.7722V24.4862Z",
    fill: "#E57139"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8664 29.0939L66.1783 28.1179V27.4039L67.8664 28.3799V29.0939Z",
    fill: "#FB944B"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1782 28.1177L64.4883 27.1436V26.4277L66.1782 27.4037V28.1177Z",
    fill: "#CE3459"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M64.489 27.143L62.7991 26.167V25.4531L64.489 26.4272V27.143Z",
    fill: "#20196F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_722_15716",
    x1: 53.3245,
    y1: 35.5867,
    x2: 85.1392,
    y2: 35.5867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#CCD1F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#B9BEE4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_722_15716",
    x1: 59.3462,
    y1: 40.0014,
    x2: 62.2742,
    y2: 34.9315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#71A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4675B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_722_15716",
    x1: 79.1183,
    y1: 40.0014,
    x2: 76.1903,
    y2: 34.9315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#71A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4675B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_722_15716",
    x1: 48.0969,
    y1: 48.6039,
    x2: 66.0712,
    y2: 48.6039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#DAE0F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#E0E5F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F6FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_722_15716",
    x1: 47.7407,
    y1: 47.9981,
    x2: 65.2554,
    y2: 47.9981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#CED3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#C7CCF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#BBC0E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_722_15716",
    x1: 90.7238,
    y1: 47.9981,
    x2: 73.2091,
    y2: 47.9981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#CED3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#C7CCF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#BBC0E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_722_15716",
    x1: 73.2091,
    y1: 43.7295,
    x2: 75.9776,
    y2: 43.7295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#DAE0F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#E5E8F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F1F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_722_15716",
    x1: 73.2091,
    y1: 39.1574,
    x2: 91.4302,
    y2: 39.1574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFE4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#E9ECF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#F9FAFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_722_15716",
    x1: 49.1558,
    y1: 43.8204,
    x2: 60.7653,
    y2: 43.8204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4CAE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#E4E7F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_722_15716",
    x1: 50.4212,
    y1: 37.8466,
    x2: 49.8714,
    y2: 38.7987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CED3F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_722_15716",
    x1: 51.7029,
    y1: 37.1077,
    x2: 51.1532,
    y2: 38.0598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CED3F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_722_15716",
    x1: 60.2366,
    y1: 41.0144,
    x2: 64.4349,
    y2: 41.0144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE0F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E8ECF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_722_15716",
    x1: 79.9146,
    y1: 43.5461,
    x2: 90.6467,
    y2: 43.5461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#C4CAE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CDD2EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E5E8F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_722_15716",
    x1: 78.9771,
    y1: 44.3348,
    x2: 88.6059,
    y2: 44.3348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#CED3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#B5BADD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#A5ABCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_722_15716",
    x1: 87.6376,
    y1: 55.3958,
    x2: 119.454,
    y2: 55.3958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#CCD1F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#B9BEE4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_722_15716",
    x1: 93.6588,
    y1: 59.815,
    x2: 96.5868,
    y2: 54.7432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#477DEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4675B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_722_15716",
    x1: 82.4111,
    y1: 68.4131,
    x2: 100.385,
    y2: 68.4131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#DAE0F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#E0E5F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F6FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_722_15716",
    x1: 82.2938,
    y1: 67.6833,
    x2: 99.8066,
    y2: 67.6833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#CED3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#C7CCF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#BBC0E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_722_15716",
    x1: 91.7726,
    y1: 62.525,
    x2: 97.7824,
    y2: 62.525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4CAE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#E4E7F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_722_15716",
    x1: 85.0774,
    y1: 64.9873,
    x2: 88.1915,
    y2: 64.9873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4CAE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#E4E7F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_722_15716",
    x1: 83.2392,
    y1: 63.1475,
    x2: 84.7887,
    y2: 63.1475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#362E94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#413AA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#4D47BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#544FC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5652CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_722_15716",
    x1: 82.0897,
    y1: 64.413,
    x2: 86.7303,
    y2: 64.413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5652CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#544FC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#4D47BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#413AA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#362E94"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_722_15716",
    x1: 19.0114,
    y1: 55.3969,
    x2: 50.828,
    y2: 55.3969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#CCD1F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#B9BEE4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_722_15716",
    x1: 44.8044,
    y1: 59.8131,
    x2: 41.8784,
    y2: 54.7432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#71A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4675B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_722_15716",
    x1: 56.41,
    y1: 67.8084,
    x2: 38.8972,
    y2: 67.8084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#CED3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#C7CCF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#BBC0E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_722_15716",
    x1: 38.8972,
    y1: 63.5398,
    x2: 41.6657,
    y2: 63.5398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#DAE0F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#E5E8F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F1F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_722_15716",
    x1: 38.8975,
    y1: 58.9692,
    x2: 57.1186,
    y2: 58.9692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFE4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#E9ECF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#F9FAFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_722_15716",
    x1: 43.6715,
    y1: 62.528,
    x2: 47.0419,
    y2: 62.528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_722_15716",
    x1: 44.9458,
    y1: 61.9628,
    x2: 44.059,
    y2: 60.4267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F6FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#BBC0E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_722_15716",
    x1: 46.0225,
    y1: 62.422,
    x2: 44.2015,
    y2: 59.2681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#BBC0E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#C7CBEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#E6E8F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#F6F6FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_722_15716",
    x1: 48.4893,
    y1: 63.3451,
    x2: 56.7225,
    y2: 63.3451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#C4CAE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CDD2EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E5E8F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_722_15716",
    x1: 47.769,
    y1: 63.9467,
    x2: 55.1555,
    y2: 63.9467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#CED3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#B5BADD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#A5ABCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_722_15716",
    x1: 53.3245,
    y1: 75.2076,
    x2: 85.1392,
    y2: 75.2076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#CCD1F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#B9BEE4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_722_15716",
    x1: 93.9162,
    y1: 60.6513,
    x2: 97.1423,
    y2: 55.063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#CEE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#91DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#71A0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_722_15716",
    x1: 59.6028,
    y1: 40.844,
    x2: 62.8307,
    y2: 35.2557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#CEE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#91DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#71A0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_722_15716",
    x1: 78.8821,
    y1: 40.8303,
    x2: 75.656,
    y2: 35.242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#CEE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#91DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#71A0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_722_15716",
    x1: 44.5481,
    y1: 60.6532,
    x2: 41.322,
    y2: 55.0649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#CEE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#91DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#71A0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_722_15716",
    x1: 57.5069,
    y1: 75.497,
    x2: 59.063,
    y2: 78.1922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2C8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_722_15716",
    x1: 57.9196,
    y1: 74.2831,
    x2: 59.1794,
    y2: 76.4752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F6FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4CAE9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_722_15716",
    x1: 60.9195,
    y1: 77.4776,
    x2: 62.4756,
    y2: 80.1728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2C8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_722_15716",
    x1: 61.3389,
    y1: 76.2753,
    x2: 62.5978,
    y2: 78.4658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#477DEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_722_15716",
    x1: 64.333,
    y1: 79.4558,
    x2: 65.8882,
    y2: 82.1494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2C8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_722_15716",
    x1: 64.7574,
    y1: 78.2645,
    x2: 66.0172,
    y2: 80.4566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F6FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4CAE9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_722_15716",
    x1: 57.5094,
    y1: 71.3184,
    x2: 59.0656,
    y2: 74.0136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2C8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_722_15716",
    x1: 57.9278,
    y1: 70.0863,
    x2: 59.1868,
    y2: 72.2768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#477DEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_722_15716",
    x1: 60.9195,
    y1: 73.2983,
    x2: 62.4746,
    y2: 75.9918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2C8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_722_15716",
    x1: 61.3472,
    y1: 72.0786,
    x2: 62.606,
    y2: 74.269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F6FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4CAE9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_722_15716",
    x1: 64.3321,
    y1: 75.2745,
    x2: 65.8883,
    y2: 77.9697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2C8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_722_15716",
    x1: 64.7657,
    y1: 74.0707,
    x2: 66.0256,
    y2: 76.2629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#477DEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_722_15716",
    x1: 108.676,
    y1: 63.835,
    x2: 108.676,
    y2: 63.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#20196F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#3F39A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#5F5AD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B67E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_722_15716",
    x1: 107.548,
    y1: 60.9031,
    x2: 107.818,
    y2: 61.3721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#20196F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#3F39A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#5F5AD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B67E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_722_15716",
    x1: 109.15,
    y1: 63.5044,
    x2: 107.653,
    y2: 60.9657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#20196F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#2D2785"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#4F49BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#635FDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#6B67E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#5F5AD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#3F39A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#20196F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_722_15716",
    x1: 118.014,
    y1: 58.4397,
    x2: 118.014,
    y2: 58.0447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#20196F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#3F39A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#5F5AD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B67E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_722_15716",
    x1: 116.885,
    y1: 55.513,
    x2: 117.157,
    y2: 55.9839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#20196F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#3F39A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#5F5AD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B67E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_722_15716",
    x1: 118.483,
    y1: 58.1022,
    x2: 116.987,
    y2: 55.5616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#20196F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#2D2785"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#4F49BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#635FDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#6B67E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#5F5AD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#3F39A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#20196F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_722_15716",
    x1: 25.0422,
    y1: 51.3114,
    x2: 30.7282,
    y2: 61.205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#EBEDF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_722_15716",
    x1: 23.9746,
    y1: 50.5278,
    x2: 29.6597,
    y2: 60.3751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#CFD2ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#BBC0E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_722_15716",
    x1: 69.364,
    y1: 26.3019,
    x2: 80.9639,
    y2: 26.3019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE0F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#EFF2FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_722_15716",
    x1: 58.8982,
    y1: 28.7558,
    x2: 79.5669,
    y2: 28.7558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#CED3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#BBC0E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_722_15716",
    x1: 34.6066,
    y1: 46.4909,
    x2: 46.2066,
    y2: 46.4909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE0F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#EFF2FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_722_15716",
    x1: 24.1403,
    y1: 48.943,
    x2: 44.8089,
    y2: 48.943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#CED3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#BBC0E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_722_15716",
    x1: 69.364,
    y1: 65.9245,
    x2: 80.9639,
    y2: 65.9245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE0F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#EFF2FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_722_15716",
    x1: 58.8982,
    y1: 68.3761,
    x2: 79.5669,
    y2: 68.3761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#CED3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#BBC0E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_722_15716",
    x1: 103.679,
    y1: 46.1142,
    x2: 115.277,
    y2: 46.1142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE0F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#EFF2FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_722_15716",
    x1: 93.2108,
    y1: 48.5666,
    x2: 113.88,
    y2: 48.5666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#CED3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#BBC0E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_722_15716",
    x1: 98.3184,
    y1: 45.1366,
    x2: 111.369,
    y2: 45.1366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#EBEDF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_722_15716",
    x1: 64.004,
    y1: 25.3279,
    x2: 77.0546,
    y2: 25.3279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#EBEDF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_722_15716",
    x1: 29.2461,
    y1: 45.5149,
    x2: 42.2967,
    y2: 45.5149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#EBEDF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_722_15716",
    x1: 64.004,
    y1: 64.947,
    x2: 77.0546,
    y2: 64.947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#EBEDF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTranslation);
export default __webpack_public_path__ + "static/media/Translation.88e7a81cc1363cc827032841f9809391.svg";
export { ForwardRef as ReactComponent };